
/* ================= DATA ================= */
var GST=1.03, RATE_22K=(typeof window !== 'undefined' && window.ASTR && window.ASTR.goldRate)?+window.ASTR.goldRate:13100;
var goldRate=RATE_22K, RATE_24K=Math.round(RATE_22K/0.9167);
var DESIGN_WEIGHT_G=6.0, MAKING=0.15;
var PURITY={"9K":0.375,"14K":0.585,"18K":0.75};
var METALS=[
  {id:"silver-rhodium",name:"Silver · Rhodium",kind:"silver",flat:3500,sw:"#d9dde2",info:"925 silver with a bright rhodium polish — cool, white and tarnish-resistant."},
  {id:"silver-guilded",name:"Silver · Guilded",kind:"silver",flat:4500,sw:"#e6d3ad",info:"925 silver with a warm gilded (gold-tone) polish."},
  {id:"9K",name:"Gold 9K",kind:"gold",sw:"#e7d6a8",info:"37.5% pure gold — the most accessible gold, durable and everyday."},
  {id:"14K",name:"Gold 14K",kind:"gold",sw:"#e3c483",info:"58.5% pure gold — the balance of richness and strength."},
  {id:"18K",name:"Gold 18K",kind:"gold",sw:"#d8b25e",info:"75% pure gold — deep colour and heirloom quality."}
];
var STONES=[
  {id:"diamond",name:"Diamond",alt:"Stone of Invincibility",color:"#eaf2f8",add:60000,info:"Master healer. Purity, strength, clarity; amplifies intention and the crown chakra."},
  {id:"blue-sapphire",name:"Blue Sapphire",alt:"Neelam · Saturn",color:"#8aa0d8",add:18000,info:"Wisdom, truth, discipline. Calms the mind, activates the third eye, shields energy."},
  {id:"yellow-sapphire",name:"Yellow Sapphire",alt:"Pukhraj · Jupiter",color:"#ecd98a",add:15000,info:"Wealth, wisdom, prosperity. Clears confusion and supports the solar plexus."},
  {id:"emerald",name:"Emerald",alt:"Panna · Mercury",color:"#8fc7a3",add:22000,info:"Stone of successful love. Opens the heart, brings renewal, calm and clarity."},
  {id:"ruby",name:"Ruby",alt:"Manik · The Sun",color:"#d98a97",add:20000,info:"King of gemstones. Passion, vitality, courage; grounds the root, warms the heart."},
  {id:"amethyst",name:"Amethyst",alt:"The Sober Stone",color:"#b89ad9",add:6000,info:"Calm, protection, clarity. Eases anxiety, supports rest, opens third eye & crown."}
];
var DESIGNS=[
  {id:"aara-purple",shape:"AARA",category:"AARA",rings:5,role:"Divine Masculine Energy",element:"Space",color:"#9a7ec4",name:"AARA · Crown Purple",capt:"The Divine Masculine Energy, held in Crown Purple.",blurb:"The cosmic void from which all creation emerges",photos:["aara-purple-gold-1","aara-purple-gold-4","aara-purple-gold-2","aara-purple-gold-3","aara-purple-gold-5"]},
  {id:"aara-orange",shape:"AARA",category:"AARA",rings:5,role:"Divine Masculine Energy",element:"Fire",color:"#e2a279",name:"AARA · Sacral Orange",capt:"The Divine Masculine Energy, alight in Sacral Orange.",blurb:"Transforming fire of desire into physical reality",photos:["aara-orange-gold-1","aara-orange-gold-6","aara-orange-gold-2","aara-orange-gold-3","aara-orange-silver-1"]},
  {id:"deu-blue",shape:"DEU",category:"DEU",rings:6,role:"Divine Feminine Energy",element:"Water",color:"#7fa9d0",name:"DEU · Ocean Blue",capt:"The Divine Feminine Energy, flowing in Ocean Blue.",blurb:"The oceanic tide — fluid, adaptable and infinite",photos:["deu-blue-silver-1","deu-blue-silver-4","deu-blue-silver-3","deu-blue-silver-2","deu-blue-gold-1"]},
  {id:"deu-green",shape:"DEU",category:"DEU",rings:6,role:"Divine Feminine Energy",element:"Earth",color:"#93bd99",name:"DEU · Earth Green",capt:"The Divine Feminine Energy, rooted in Earth Green.",blurb:"The nurturing sacred womb",photos:["deu-green-gold-1","deu-green-gold-4","deu-green-gold-3","deu-green-gold-2","deu-green-gold-5"]}
];
var SHAPE_INFO={AARA:"AARA — Representing the Divine Masculine Energy. The sacred structural framework.",DEU:"DEU — Representing the Divine Feminine Energy. The flowing womb of creative energy."};
var ELEMENT_SIZES={AARA:{Small:"17.5 mm",Big:"22 mm"},DEU:{Small:"19.5 mm",Big:"23.75 mm"}};
var SIZES={necklace:["16 in","18 in","20 in","22 in","24 in"],bracelet:["14 cm","16 cm","18 cm","20 cm"]};
var SIZE_INFO={necklace:"Chain length around the neck. See the Size Guide to picture each drop.",bracelet:"Bracelet circumference. Measure your wrist and add ~1.5–2 cm for comfort."};
var wishlist={};

var AARA_RINGS = [
  { num: 1, name: "Outer Perimeter · 18K Gold Bezel", color: "#d4af37", desc: "The Sovereign Boundary — establishes the divine masculine energy structural framework and protects sacred intention." },
  { num: 2, name: "Ring 2 · Pillar of Architecture", color: "#855ca8", desc: "The Scaffolding of Consciousness — providing firmness, direction, and unwavering purpose." },
  { num: 3, name: "Ring 3 · The Alchemical Hearth", color: "#f0a746", desc: "The Fire of Will — transmuting intention into tangible physical reality through sacred inner agni." },
  { num: 4, name: "Ring 4 · Starlight Gateway", color: "#d5c2e6", desc: "The Inner Sanctum — clarity of thought, intuition, and alignment with celestial higher truth." },
  { num: 5, name: "Center Core · Diamond Singularity", color: "#ffffff", desc: "Pure Solitaire Consciousness — the uncreated divine point from which all masculine architecture expands." }
];

var DEU_RINGS = [
  { num: 1, name: "Outer Perimeter · Moonlit Pearl Rim", color: "#a8d1ed", desc: "The Fluid Horizon — boundless grace embracing all existence without rigid edges; pure adaptability." },
  { num: 2, name: "Ring 2 · The Womb of Waters", color: "#285999", desc: "The Primordial Ocean — boundless fertility, continuous birth, and infinite creative potential." },
  { num: 3, name: "Ring 3 · Tidal Intuition", color: "#4e89c7", desc: "The Sacred Current — trusting instinct, emotional depth, and connection to cosmic rhythms." },
  { num: 4, name: "Ring 4 · The Breath of Prana", color: "#5aa87c", desc: "The Living Tide — botanical vitality, flourishing growth, and constant gentle renewal." },
  { num: 5, name: "Ring 5 · The Sanctuary of Peace", color: "#83c29d", desc: "The Liquid Heart — tranquility, emotional sovereignty, and maternal healing." },
  { num: 6, name: "Center Core · Blue Sapphire Dewdrop", color: "#16325c", desc: "The Sacred Wellspring — the eternal source of intuitive wisdom, love, and creative life." }
];

/* ================= MULTI-CURRENCY & WORLDWIDE ================= */
var CURRENCIES = {
  INR: { code: 'INR', symbol: '₹', rate: 1.0, locale: 'en-IN', name: 'Indian Rupee' },
  USD: { code: 'USD', symbol: '$', rate: 0.01044, locale: 'en-US', name: 'US Dollar' },
  EUR: { code: 'EUR', symbol: '€', rate: 0.00895, locale: 'de-DE', name: 'Euro' },
  GBP: { code: 'GBP', symbol: '£', rate: 0.00766, locale: 'en-GB', name: 'British Pound' },
  AED: { code: 'AED', symbol: 'AED ', rate: 0.03836, locale: 'en-AE', name: 'UAE Dirham' },
  CAD: { code: 'CAD', symbol: 'CA$', rate: 0.01447, locale: 'en-CA', name: 'Canadian Dollar' },
  AUD: { code: 'AUD', symbol: 'AU$', rate: 0.01460, locale: 'en-AU', name: 'Australian Dollar' },
  SGD: { code: 'SGD', symbol: 'SG$', rate: 0.01327, locale: 'en-SG', name: 'Singapore Dollar' }
};

var currentCurrency = 'INR';
try {
  var savedCur = localStorage.getItem('astr_currency');
  if (savedCur && CURRENCIES[savedCur]) currentCurrency = savedCur;
} catch(e){}

function formatMoney(inrAmount, showSymbol) {
  var cur = CURRENCIES[currentCurrency] || CURRENCIES.INR;
  var converted = inrAmount * cur.rate;
  var sym = showSymbol !== false ? cur.symbol : '';
  if (cur.code === 'INR') {
    return sym + Number(Math.round(converted)).toLocaleString('en-IN');
  } else {
    return sym + Number(Math.round(converted)).toLocaleString(cur.locale);
  }
}

function getConvertedValue(inrAmount) {
  var cur = CURRENCIES[currentCurrency] || CURRENCIES.INR;
  return Math.round(inrAmount * cur.rate);
}

function toast(msg, duration) {
  if (typeof document === 'undefined') return;
  var container = document.getElementById('astrToastContainer');
  if (!container) {
    container = document.createElement('div');
    container.id = 'astrToastContainer';
    container.className = 'astr-toast-container';
    container.setAttribute('aria-live', 'polite');
    container.setAttribute('aria-atomic', 'true');
    document.body.appendChild(container);
  }

  // Prevent toast pileup: remove oldest toasts if more than 3
  if (container && container.children) {
    while (container.children.length >= 3) {
      var oldest = container.children[0];
      if (oldest) container.removeChild(oldest);
    }
  }

  var t = document.createElement('div');
  t.className = 'astr-toast';
  t.innerHTML = '<span class="astr-toast-icon">✦</span><span>' + msg + '</span>';
  container.appendChild(t);

  if (typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(function() { t.classList.add('show'); });
  } else {
    t.classList.add('show');
  }

  var d = duration || 3200;
  setTimeout(function() {
    t.classList.remove('show');
    setTimeout(function() {
      if (t.parentNode) t.parentNode.removeChild(t);
    }, 350);
  }, d);
}

function setCurrency(code) {
  if (CURRENCIES[code]) {
    currentCurrency = code;
    try { localStorage.setItem('astr_currency', code); } catch(e){}
    var sel1 = document.getElementById('curSelector');
    if (sel1) sel1.value = code;
    var sel2 = document.getElementById('mobCurSelector');
    if (sel2) sel2.value = code;
    updateRateTag();
    renderHome();
    if (document.getElementById('page-aara') && document.getElementById('page-aara').classList.contains('active')) renderAara();
    if (document.getElementById('page-deu') && document.getElementById('page-deu').classList.contains('active')) renderDeu();
    if (document.getElementById('page-product') && document.getElementById('page-product').classList.contains('active')) {
      renderProduct();
    }
    if (typeof ASTR_CART !== 'undefined' && ASTR_CART.renderDrawer) {
      ASTR_CART.renderDrawer();
    }
    toast('Currency set to ' + code + ' (' + CURRENCIES[code].name + ')');
  }
}

function updateRateTag() {
  if (typeof document === 'undefined') return;
  var tag = document.getElementById('rateTag');
  if (!tag) return;
  var cur = CURRENCIES[currentCurrency] || CURRENCIES.INR;
  var pulse = '<span style="display:inline-block;width:7px;height:7px;border-radius:50%;background:#4ade80;margin-right:6px;vertical-align:middle;box-shadow:0 0 8px #4ade80" title="Live Gold Sync Active"></span>';
  tag.innerHTML = pulse + formatMoney(goldRate) + '/g';
}

function inr(n){return Number(Math.round(n)).toLocaleString('en-IN');}
function design(id){
  if (!id || typeof id !== 'string') return undefined;
  var clean = id.trim();
  var lower = clean.toLowerCase().replace(/[\s_]+/g, '-');
  var stripped = lower.replace(/[^a-z0-9]/g, '');
  var found = DESIGNS.find(function(d){
    return d.id === clean || d.id === lower || d.name.toLowerCase() === clean.toLowerCase() || d.name.toLowerCase() === lower;
  });
  if (found) return found;
  // Match by element name (e.g. 'fire', 'space', 'water', 'earth')
  found = DESIGNS.find(function(d){
    return d.element.toLowerCase() === clean.toLowerCase() || d.element.toLowerCase() === lower;
  });
  if (found) return found;
  // Match partial name, sub-title or slug (e.g. 'sacral orange', 'sacral-orange', 'crown purple', 'ocean blue', 'earth green')
  return DESIGNS.find(function(d){
    var dLower = d.name.toLowerCase();
    var idLower = d.id.toLowerCase();
    var dStripped = dLower.replace(/[^a-z0-9]/g, '');
    var idStripped = idLower.replace(/[^a-z0-9]/g, '');
    return dLower.indexOf(clean.toLowerCase()) >= 0 || idLower.indexOf(lower) >= 0 ||
           (stripped.length >= 3 && (dStripped.indexOf(stripped) >= 0 || idStripped.indexOf(stripped) >= 0));
  });
}
function mById(id){
  if (!id || typeof id !== 'string') return undefined;
  var clean = id.trim();
  var lower = clean.toLowerCase().replace(/[\s_]+/g, '-');
  if (lower === '18k' || lower === '18kt' || lower === '18k-gold' || lower === 'gold-18k' || lower === '18k gold' || lower === '18-k') return METALS.find(function(m){ return m.id === '18K'; });
  if (lower === '14k' || lower === '14kt' || lower === '14k-gold' || lower === 'gold-14k' || lower === '14k gold' || lower === '14-k') return METALS.find(function(m){ return m.id === '14K'; });
  if (lower === '9k' || lower === '9kt' || lower === '9k-gold' || lower === 'gold-9k' || lower === '9k gold' || lower === '9-k') return METALS.find(function(m){ return m.id === '9K'; });
  if (lower === 'silver' || lower === 'rhodium' || lower === 'silver-rhodium' || lower === 'rhodium silver' || lower === '925-silver' || lower === 'silver 925') return METALS.find(function(m){ return m.id === 'silver-rhodium'; });
  if (lower === 'gilded' || lower === 'guilded' || lower === 'silver-guilded' || lower === 'silver-gilded' || lower === 'gilded silver') return METALS.find(function(m){ return m.id === 'silver-guilded'; });
  return METALS.find(function(m){
    return m.id === clean || m.id === lower || m.name.toLowerCase() === lower || m.name.toLowerCase() === clean.toLowerCase();
  });
}
function sById(id){
  if (!id || typeof id !== 'string') return undefined;
  var clean = id.trim();
  var lower = clean.toLowerCase().replace(/[\s_]+/g, '-');
  if (lower === 'sapphire') lower = 'blue-sapphire';
  var direct = STONES.find(function(s){
    return s.id === clean || s.id === lower || s.name.toLowerCase() === lower || s.name.toLowerCase() === clean.toLowerCase();
  });
  if (direct) return direct;
  // Match Vedic / Sanskrit alternate names (e.g. 'manik' -> Ruby, 'neelam' -> Blue Sapphire, 'pukhraj' -> Yellow Sapphire, 'panna' -> Emerald)
  return STONES.find(function(s){
    return (s.alt && s.alt.toLowerCase().indexOf(clean.toLowerCase()) >= 0) || (s.alt && s.alt.toLowerCase().indexOf(lower) >= 0);
  });
}
function metalCostFor(metalId, rate){var r=(typeof rate==='number'&&rate>0)?rate:goldRate;var m=mById(metalId);if(!m)return 0;return m.kind==='silver'?m.flat:DESIGN_WEIGHT_G*r/0.9167*PURITY[m.id];}
function calcFor(metalId,stoneId,rate){var metal=metalCostFor(metalId,rate),making=metal*MAKING,s=sById(stoneId),stone=s?s.add:0,sub=metal+making+stone;return{metal:metal,making:making,stone:stone,gst:sub*(GST-1),total:Math.round(sub*GST)};}
function ringArt(rings,color,stoneColor,metalColor){
  var mCol = metalColor || '#d4af37';
  var sCol = stoneColor || '#ffffff';
  var numRings = (typeof rings === 'number' && isFinite(rings) && rings > 1) ? Math.floor(rings) : 5;
  var col = color || '#9a7ec4';
  var svg='',n=numRings,outer=88,step=(outer-14)/(n-1);
  for(var i=0;i<n;i++){
    var r=(outer/2)-(i*step/2);
    var strokeCol = (i===0) ? mCol : col;
    var strokeW = (i===0) ? 2.8 : (2.4-i*0.09);
    svg+='<circle cx="100" cy="100" r="'+r.toFixed(1)+'" fill="none" stroke="'+strokeCol+'" stroke-width="'+strokeW.toFixed(2)+'" opacity="'+(1-i*0.04).toFixed(2)+'"/>';
  }
  svg+='<circle cx="100" cy="100" r="9" fill="'+sCol+'" stroke="'+mCol+'" stroke-width="1.6"/><circle cx="96" cy="96" r="3" fill="rgba(255,255,255,.7)"/>';
  return svg;
}
function tint(hex){return hex+'20';}

function inspectorSvg(shape){
  var isAara = shape === 'AARA';
  var n = isAara ? 5 : 6;
  var rings = isAara ? AARA_RINGS : DEU_RINGS;
  var svg = '';
  var outer = 88;
  var step = (outer - 18) / (n - 1);
  for (var i = 0; i < n - 1; i++){
    var r = outer - (i * step);
    var col = rings[i].color;
    svg += '<circle cx="100" cy="100" r="'+r.toFixed(1)+'" fill="none" stroke="'+col+'" stroke-width="3" opacity="0.85" class="ring-layer shape-'+shape+'-ring-'+i+'" onmouseenter="selectInspectorRing(\''+shape+'\','+i+')" onclick="selectInspectorRing(\''+shape+'\','+i+')"/>';
  }
  var coreCol = rings[n - 1].color;
  svg += '<circle cx="100" cy="100" r="11" fill="'+coreCol+'" stroke="#d4af37" stroke-width="2" class="core-stone shape-'+shape+'-ring-'+(n-1)+'" onmouseenter="selectInspectorRing(\''+shape+'\','+(n-1)+')" onclick="selectInspectorRing(\''+shape+'\','+(n-1)+')"/>';
  svg += '<circle cx="96" cy="96" r="3.5" fill="rgba(255,255,255,.8)" pointer-events="none"/>';
  return svg;
}

if (typeof window !== 'undefined') {
  window.selectInspectorRing = function(shape, idx){
    var isAara = shape === 'AARA';
    var data = isAara ? AARA_RINGS : DEU_RINGS;
    var item = data[idx];
    if (!item) return;

    if (typeof document !== 'undefined') {
      var pills = document.querySelectorAll('.pill-' + shape);
      Array.prototype.forEach.call(pills, function(p, i){ p.classList.toggle('active', i === idx); });

      var card = document.getElementById('inspector-' + shape);
      if (card) {
        var targets = card.querySelectorAll('.ring-layer, .core-stone');
        Array.prototype.forEach.call(targets, function(r){ r.classList.remove('active'); });
        var target = card.querySelector('.shape-' + shape + '-ring-' + idx);
        if (target) target.classList.add('active');

        var nameEl = card.querySelector('.ring-detail-name');
        var colEl = card.querySelector('.ring-detail-color');
        var descEl = card.querySelector('.ring-detail-desc');
        if (nameEl) nameEl.textContent = item.name;
        if (colEl) { colEl.style.background = item.color; colEl.style.color = item.color; }
        if (descEl) descEl.textContent = item.desc;
      }
    }
  };
}

/* ================= ROUTER ================= */
function go(page){
  var targetId = 'page-' + page;
  var el = document.getElementById(targetId);
  var validPage = el ? page : 'home';
  el = el || document.getElementById('page-home');
  Array.prototype.forEach.call(document.querySelectorAll('.page'), function(p){ p.classList.remove('active'); });
  if (el) el.classList.add('active');
  Array.prototype.forEach.call(document.querySelectorAll('.navlinks a'), function(a){
    a.classList.toggle('on', a.getAttribute('data-nav') === validPage);
  });
  if (typeof window !== 'undefined' && typeof window.scrollTo === 'function') window.scrollTo(0, 0);
  if (validPage === 'aara') renderAara();
  if (validPage === 'deu') renderDeu();
  if (validPage === 'product') renderProduct();
  setTimeout(function(){ observeReveals(); bindTilt(); bindMagnetic(); }, 30);
}
function closeMM(){document.getElementById('mm').classList.remove('open');}

/* ================= HOME / LISTINGS (2 PER CATEGORY) ================= */
function fromPrice(){
  if (typeof window !== 'undefined' && window.ASTR && window.ASTR.variants && window.ASTR.variants.length > 0) {
    var min = Infinity;
    for (var i = 0; i < window.ASTR.variants.length; i++) {
      var p = window.ASTR.variants[i].price;
      if (p > 0 && p < min) min = p;
    }
    if (min !== Infinity) return min / 100;
  }
  return 8500;
}
function designCard(d,type){
  var t = type || 'necklace';
  var wid = d.id + '-' + t;
  var assets = window.ASTR_ASSETS || {};
  var artContent = '';
  if (d.photos && d.photos.length > 0 && assets[d.photos[0]]) {
    var mainSrc = assets[d.photos[0]];
    var hoverSrc = assets[d.photos[2] || d.photos[1]] || mainSrc;
    artContent = '<img src="'+mainSrc+'" class="pcard-img main-shot" alt="'+d.name+'" loading="lazy">' +
      '<img src="'+hoverSrc+'" class="pcard-img hover-shot" alt="'+d.name+' on model" loading="lazy">';
  } else {
    artContent = '<svg viewBox="0 0 200 200">'+ringArt(d.rings,d.color,'#C3A567')+'</svg>';
  }
  return '<div class="pcard reveal in tilt" onclick="openProduct(\''+d.id+'\',\''+t+'\')">'+
    '<div class="heart'+(wishlist[wid]?' on':'')+'" data-wid="'+wid+'" onclick="toggleWish(event,\''+wid+'\',this)">♥</div>'+
    '<div class="art" style="background:radial-gradient(circle at 50% 38%,#fff,'+tint(d.color)+' 128%)">'+artContent+'</div>'+
    '<div class="body"><div class="role">'+d.role+' · '+d.element+'</div><h3>'+d.name+'</h3>'+
    '<div class="from">from '+formatMoney(fromPrice())+'</div></div></div>';
}
function renderHome(){
  var el1 = document.getElementById('homeElements');
  var assets = window.ASTR_ASSETS || {};
  if (el1) {
    el1.innerHTML=DESIGNS.map(function(d){
      var ek = d.element.toLowerCase();
      var vid = assets['video-' + ek];
      var webp = assets['webp-' + ek];
      var mediaTag = vid
        ? '<video loop muted playsinline preload="none" poster="'+(webp||'')+'" class="elcard-video"><source src="'+vid+'" type="video/mp4"></video>'
        : (webp ? '<img src="'+webp+'" alt="'+d.element+'" class="elcard-video" loading="lazy">' : '');
      return '<div class="elcard elcard-'+ek+' reveal in" style="--halo:'+d.color+'88" onclick="openProduct(\''+d.id+'\',\'necklace\')">'+
        mediaTag+
        '<div class="elcard-scrim"></div>'+
        '<div class="elcard-text">'+
          '<div class="el">'+d.element+' · '+d.shape+'</div>'+
          '<h4>'+d.name.split('· ')[1]+'</h4>'+
          '<p>'+d.blurb+'</p>'+
        '</div>'+
      '</div>';
    }).join('');
    if (typeof window !== 'undefined' && 'IntersectionObserver' in window) {
      var videoObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var v = entry.target.querySelector('video.elcard-video');
            if (v && v.paused) {
              v.play().catch(function(){});
            }
            videoObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '300px' });
      el1.querySelectorAll('.elcard').forEach(function(card) { videoObserver.observe(card); });
    } else if (typeof window !== 'undefined') {
      el1.querySelectorAll('video.elcard-video').forEach(function(v) {
        v.autoplay = true;
        v.play().catch(function(){});
      });
    }
  }
  var el2 = document.getElementById('homeShapes');
  if (el2) {
    el2.innerHTML = [
      {
        id: 'AARA',
        name: 'AARA',
        badge: 'Divine Masculine Energy',
        category: 'Divine Masculine Energy',
        rings: 5,
        photo: assets['aara-editorial-opt2'] || assets['aara-purple-1'],
        wireframeColor: '#d4af37',
        stoneColor: '#ffffff',
        quote: '“Every ASTR creation begins with structure. Concentric architectural geometry forges an unyielding anchor of sovereign consciousness, purpose, and truth.”',
        specs: ['Vitreous Enamel Geometry', 'Hallmarked Gold Outer Bezel', 'Solitaire Crystal Core'],
        page: 'aara'
      },
      {
        id: 'DEU',
        name: 'DEU',
        badge: 'Divine Feminine Energy',
        category: 'Divine Feminine Energy',
        rings: 6,
        photo: assets['deu-editorial-opt2'] || assets['deu-blue-3'],
        wireframeColor: '#38bdf8',
        stoneColor: '#285999',
        quote: '“Creation flows endlessly from the womb. Organic contours embrace fluidity, deep intuition, and eternal renewal in boundless grace.”',
        specs: ['Vitreous Enamel Geometry', 'Hallmarked Silver & Gold Orbit', 'Ceylon Crystal Core'],
        page: 'deu'
      }
    ].map(function(s){
      var wireframeSvg = ringArt(s.rings, s.wireframeColor, s.stoneColor);
      var specsHtml = s.specs.join(' <span></span> ');

      return '<div class="shapecard reveal in" onclick="go(\''+s.page+'\')">'+
        '<div class="editorial-photo-stage">'+
          '<img src="'+s.photo+'" alt="'+s.name+' Editorial Jewellery" loading="lazy">'+
          '<div class="editorial-badge"><span class="editorial-badge-dot"></span>'+s.badge+'</div>'+
        '</div>'+
        '<div class="editorial-body">'+
          '<div class="editorial-category">'+s.category+'</div>'+
          '<h3>'+s.name+'</h3>'+
          '<div class="editorial-quote">'+s.quote+'</div>'+
          '<div class="editorial-specs">'+specsHtml+'</div>'+
          '<button class="editorial-cta-btn">Explore '+s.name+' Creations →</button>'+
        '</div>'+
      '</div>';
    }).join('');
  }
  var el3 = document.getElementById('homeNecklaces');
  if (el3) {
    el3.innerHTML=DESIGNS.map(function(d){return designCard(d,'necklace');}).join('');
  }
  setTimeout(function(){
    observeReveals();
    bindTilt();
    bindMagnetic();
  }, 10);
}
function renderAara(){
  var el = document.getElementById('listAara');
  if (el) {
    var aaraDesigns = DESIGNS.filter(function(d){ return d.shape === 'AARA'; });
    el.innerHTML = aaraDesigns.map(function(d){ return designCard(d, 'necklace'); }).join('');
  }
  setTimeout(function(){ observeReveals(); bindTilt(); bindMagnetic(); }, 10);
}
function renderDeu(){
  var el = document.getElementById('listDeu');
  if (el) {
    var deuDesigns = DESIGNS.filter(function(d){ return d.shape === 'DEU'; });
    el.innerHTML = deuDesigns.map(function(d){ return designCard(d, 'necklace'); }).join('');
  }
  setTimeout(function(){ observeReveals(); bindTilt(); bindMagnetic(); }, 10);
}
function toggleWish(e,wid,el){e.stopPropagation();wishlist[wid]=!wishlist[wid];el.classList.toggle('on',wishlist[wid]);toast(wishlist[wid]?'Saved to wishlist':'Removed from wishlist');}

/* ================= PRODUCT ================= */
var pstate={designId:"aara-purple",type:"necklace",metal:"18K",stone:"diamond",size:"18 in",elSize:"Small"};
function openProduct(designId,type){
  pstate.designId=designId;
  pstate.type=type||"necklace";
  var typeSizes = (SIZES && SIZES[pstate.type]) ? SIZES[pstate.type] : (SIZES && SIZES.necklace ? SIZES.necklace : ["16 in","18 in","20 in","22 in","24 in"]);
  pstate.size=typeSizes[1] || typeSizes[0] || "18 in";
  go('product');
}
function infoBtn(text){return '<span class="info" onclick="toggleTip(this,event)">i<span class="tip">'+text+'</span></span>';}
function chip(text,active,g,v,color){var sw=color?'<span class="sw" style="background:'+color+'"></span>':'';return '<button class="chip'+(active?' active':'')+'" data-g="'+g+'" data-v="'+v+'">'+sw+text+'</button>';}

/* ================= PRODUCT DYNAMIC CUSTOMIZATION & GALLERY ================= */

function getCustomizedPhotos(designId, metalId, type, stoneId){
  var dObj = design(designId);
  var did = dObj ? dObj.id : (designId ? String(designId).trim().toLowerCase().replace(/[\s_]+/g, '-') : '');
  var mObj = mById(metalId);
  var mid = mObj ? mObj.id : (metalId ? String(metalId).trim().toLowerCase() : '');
  var isSilver = (mObj && mObj.kind === 'silver') || mid === 'silver' || mid === 'silver-rhodium' || mid === 'silver-guilded';
  var t = type ? String(type).trim().toLowerCase() : (typeof pstate !== 'undefined' && pstate.type ? String(pstate.type).trim().toLowerCase() : 'necklace');
  var isBracelet = t === 'bracelet';
  var sObj = sById(stoneId) || (typeof pstate !== 'undefined' && pstate.stone ? sById(pstate.stone) : null);
  var sid = sObj ? sObj.id : (stoneId ? String(stoneId).trim().toLowerCase().replace(/[\s_]+/g, '-') : 'diamond');
  if (sid === 'sapphire') sid = 'blue-sapphire';

  if (did === 'aara-orange') {
    if (isSilver) {
      if (sid === 'ruby') {
        return isBracelet ? [
          { key: 'aara-orange-silver-4', label: 'Model Wrist' },
          { key: 'aara-orange-silver-1', label: 'Silk Ivory' },
          { key: 'aara-orange-silver-2', label: 'Magenta Silk' },
          { key: 'aara-orange-silver-3', label: 'Lava Agni' }
        ] : [
          { key: 'aara-orange-silver-1', label: 'Silk Ivory' },
          { key: 'aara-orange-silver-2', label: 'Magenta Silk' },
          { key: 'aara-orange-silver-3', label: 'Lava Agni' },
          { key: 'aara-orange-silver-4', label: 'Model Wrist' }
        ];
      } else if (sid === 'yellow-sapphire') {
        return isBracelet ? [
          { key: 'aara-orange-silver-4', label: 'Model Wrist' },
          { key: 'aara-orange-silver-2', label: 'Yellow Sapphire Silk' },
          { key: 'aara-orange-splash', label: 'Fire & Magma' },
          { key: 'aara-orange-silver-1', label: 'Silk Ivory' }
        ] : [
          { key: 'aara-orange-silver-2', label: 'Yellow Sapphire Silk' },
          { key: 'aara-orange-splash', label: 'Fire & Magma' },
          { key: 'aara-orange-silver-1', label: 'Silk Ivory' },
          { key: 'aara-orange-silver-4', label: 'Model Wrist' }
        ];
      } else if (sid === 'diamond') {
        return isBracelet ? [
          { key: 'aara-orange-silver-4', label: 'Model Wrist' },
          { key: 'aara-orange-silver-3', label: 'Diamond Lava Silk' },
          { key: 'aara-orange-silver-1', label: 'Silk Ivory' },
          { key: 'aara-orange-silver-2', label: 'Magenta Silk' }
        ] : [
          { key: 'aara-orange-silver-3', label: 'Diamond Lava Silk' },
          { key: 'aara-orange-silver-1', label: 'Silk Ivory' },
          { key: 'aara-orange-silver-2', label: 'Magenta Silk' },
          { key: 'aara-orange-silver-4', label: 'Model Wrist' }
        ];
      } else if (sid === 'emerald') {
        return isBracelet ? [
          { key: 'aara-orange-silver-4', label: 'Emerald Model Wrist' },
          { key: 'aara-orange-silver-1', label: 'Silk Ivory' },
          { key: 'aara-orange-silver-2', label: 'Magenta Silk' },
          { key: 'aara-orange-silver-3', label: 'Lava Agni' }
        ] : [
          { key: 'aara-orange-silver-4', label: 'Emerald Coral Silk' },
          { key: 'aara-orange-silver-1', label: 'Silk Ivory' },
          { key: 'aara-orange-silver-2', label: 'Magenta Silk' },
          { key: 'aara-orange-silver-3', label: 'Lava Agni' }
        ];
      } else if (sid === 'amethyst') {
        return isBracelet ? [
          { key: 'aara-orange-silver-4', label: 'Model Wrist' },
          { key: 'aara-orange-silver-2', label: 'Amethyst Silk Drape' },
          { key: 'aara-orange-silver-3', label: 'Lava Agni' },
          { key: 'aara-orange-silver-1', label: 'Silk Ivory' }
        ] : [
          { key: 'aara-orange-silver-2', label: 'Amethyst Silk Drape' },
          { key: 'aara-orange-silver-3', label: 'Lava Agni' },
          { key: 'aara-orange-silver-1', label: 'Silk Ivory' },
          { key: 'aara-orange-silver-4', label: 'Model Wrist' }
        ];
      } else if (sid === 'blue-sapphire') {
        return isBracelet ? [
          { key: 'aara-orange-silver-4', label: 'Model Wrist' },
          { key: 'aara-orange-silver-3', label: 'Blue Topaz Lava' },
          { key: 'aara-orange-silver-1', label: 'Silk Ivory' },
          { key: 'aara-orange-silver-2', label: 'Magenta Silk' }
        ] : [
          { key: 'aara-orange-silver-3', label: 'Blue Topaz Lava' },
          { key: 'aara-orange-silver-1', label: 'Silk Ivory' },
          { key: 'aara-orange-silver-2', label: 'Magenta Silk' },
          { key: 'aara-orange-silver-4', label: 'Model Wrist' }
        ];
      } else {
        return [
          { key: 'aara-orange-silver-1', label: 'Silk Ivory' },
          { key: 'aara-orange-silver-2', label: 'Magenta Silk' },
          { key: 'aara-orange-silver-3', label: 'Lava Agni' },
          { key: 'aara-orange-silver-4', label: 'Model Wrist' }
        ];
      }
    } else {
      // Gold Setting
      if (sid === 'ruby') {
        return isBracelet ? [
          { key: 'aara-orange-gold-2', label: 'Model Wrist' },
          { key: 'aara-orange-gold-5', label: 'Model Hands' },
          { key: 'aara-orange-gold-6', label: 'Muse Portrait' },
          { key: 'aara-orange-gold-1', label: 'Ruby Velvet' },
          { key: 'aara-orange-gold-3', label: 'Royal Satin' },
          { key: 'aara-orange-gold-4', label: 'Studio' }
        ] : [
          { key: 'aara-orange-gold-1', label: 'Ruby Velvet' },
          { key: 'aara-orange-gold-3', label: 'Royal Satin' },
          { key: 'aara-orange-gold-4', label: 'Studio' },
          { key: 'aara-orange-gold-6', label: 'Muse Portrait' },
          { key: 'aara-orange-gold-2', label: 'Model Wrist' },
          { key: 'aara-orange-gold-5', label: 'Model Hands' }
        ];
      } else if (sid === 'yellow-sapphire') {
        return isBracelet ? [
          { key: 'aara-orange-gold-2', label: 'Model Wrist' },
          { key: 'aara-orange-splash', label: 'Yellow Sapphire Splash' },
          { key: 'aara-orange-gold-5', label: 'Model Hands' },
          { key: 'aara-orange-gold-3', label: 'Royal Satin' },
          { key: 'aara-orange-gold-1', label: 'Burgundy Velvet' }
        ] : [
          { key: 'aara-orange-splash', label: 'Yellow Sapphire Splash' },
          { key: 'aara-orange-gold-3', label: 'Royal Satin' },
          { key: 'aara-orange-gold-1', label: 'Burgundy Velvet' },
          { key: 'aara-orange-gold-6', label: 'Muse Portrait' },
          { key: 'aara-orange-gold-2', label: 'Model Wrist' }
        ];
      } else if (sid === 'diamond') {
        return isBracelet ? [
          { key: 'aara-orange-gold-2', label: 'Model Wrist' },
          { key: 'aara-orange-gold-1', label: 'Diamond Burgundy Velvet' },
          { key: 'aara-orange-gold-5', label: 'Model Hands' },
          { key: 'aara-orange-gold-3', label: 'Royal Satin' },
          { key: 'aara-orange-gold-6', label: 'Muse Portrait' }
        ] : [
          { key: 'aara-orange-gold-1', label: 'Diamond Burgundy Velvet' },
          { key: 'aara-orange-gold-3', label: 'Royal Satin' },
          { key: 'aara-orange-gold-4', label: 'Studio' },
          { key: 'aara-orange-gold-6', label: 'Muse Portrait' },
          { key: 'aara-orange-gold-2', label: 'Model Wrist' }
        ];
      } else if (sid === 'emerald') {
        return isBracelet ? [
          { key: 'aara-orange-gold-2', label: 'Model Wrist' },
          { key: 'aara-orange-gold-crystal', label: 'Emerald Sage Geode' },
          { key: 'aara-orange-gold-5', label: 'Model Hands' },
          { key: 'aara-orange-gold-3', label: 'Royal Satin' },
          { key: 'aara-orange-gold-1', label: 'Burgundy Velvet' }
        ] : [
          { key: 'aara-orange-gold-crystal', label: 'Emerald Sage Geode' },
          { key: 'aara-orange-gold-1', label: 'Burgundy Velvet' },
          { key: 'aara-orange-gold-3', label: 'Royal Satin' },
          { key: 'aara-orange-gold-6', label: 'Muse Portrait' },
          { key: 'aara-orange-gold-2', label: 'Model Wrist' }
        ];
      } else if (sid === 'amethyst') {
        return isBracelet ? [
          { key: 'aara-orange-gold-2', label: 'Model Wrist' },
          { key: 'aara-orange-gold-shadows', label: 'Amethyst Palm Shadows' },
          { key: 'aara-orange-splash', label: 'Amethyst Magma Splash' },
          { key: 'aara-orange-gold-5', label: 'Model Hands' },
          { key: 'aara-orange-gold-3', label: 'Royal Satin' }
        ] : [
          { key: 'aara-orange-gold-shadows', label: 'Amethyst Palm Shadows' },
          { key: 'aara-orange-splash', label: 'Amethyst Magma Splash' },
          { key: 'aara-orange-gold-3', label: 'Royal Satin' },
          { key: 'aara-orange-gold-1', label: 'Burgundy Velvet' },
          { key: 'aara-orange-gold-2', label: 'Model Wrist' }
        ];
      } else if (sid === 'blue-sapphire') {
        return isBracelet ? [
          { key: 'aara-orange-gold-2', label: 'Model Wrist' },
          { key: 'aara-orange-splash', label: 'Sacral Resonance Splash' },
          { key: 'aara-orange-gold-5', label: 'Model Hands' },
          { key: 'aara-orange-gold-1', label: 'Burgundy Velvet' },
          { key: 'aara-orange-gold-3', label: 'Royal Satin' }
        ] : [
          { key: 'aara-orange-splash', label: 'Sacral Resonance Splash' },
          { key: 'aara-orange-gold-1', label: 'Burgundy Velvet' },
          { key: 'aara-orange-gold-3', label: 'Royal Satin' },
          { key: 'aara-orange-gold-6', label: 'Muse Portrait' },
          { key: 'aara-orange-gold-2', label: 'Model Wrist' }
        ];
      } else {
        return isBracelet ? [
          { key: 'aara-orange-gold-2', label: 'Model Wrist' },
          { key: 'aara-orange-gold-5', label: 'Model Hands' },
          { key: 'aara-orange-gold-1', label: 'Ruby Velvet' },
          { key: 'aara-orange-gold-3', label: 'Royal Satin' }
        ] : [
          { key: 'aara-orange-gold-1', label: 'Ruby Velvet' },
          { key: 'aara-orange-gold-3', label: 'Royal Satin' },
          { key: 'aara-orange-gold-4', label: 'Studio' },
          { key: 'aara-orange-gold-2', label: 'Model Wrist' }
        ];
      }
    }
  }

  if (did === 'aara-purple') {
    if (isSilver) {
      if (sid === 'yellow-sapphire') {
        return isBracelet ? [
          { key: 'aara-purple-gold-4', label: 'Model Wrist' },
          { key: 'aara-purple-2', label: 'Perspective Studio' },
          { key: 'aara-purple-gold-2', label: 'Yellow Sapphire Terracotta' },
          { key: 'aara-purple-1', label: 'Baseline Frontal' }
        ] : [
          { key: 'aara-purple-2', label: 'Perspective Studio' },
          { key: 'aara-purple-gold-2', label: 'Yellow Sapphire Terracotta' },
          { key: 'aara-purple-1', label: 'Baseline Frontal' },
          { key: 'aara-purple-gold-4', label: 'Model Wrist' }
        ];
      } else if (sid === 'amethyst') {
        return isBracelet ? [
          { key: 'aara-purple-gold-4', label: 'Model Wrist' },
          { key: 'aara-purple-3', label: 'Amethyst Macro Bezel' },
          { key: 'aara-purple-gold-3', label: 'Crimson Velvet' },
          { key: 'aara-purple-1', label: 'Baseline Frontal' }
        ] : [
          { key: 'aara-purple-3', label: 'Amethyst Macro Bezel' },
          { key: 'aara-purple-gold-3', label: 'Crimson Velvet' },
          { key: 'aara-purple-1', label: 'Baseline Frontal' },
          { key: 'aara-purple-gold-4', label: 'Model Wrist' }
        ];
      } else if (sid === 'emerald') {
        return isBracelet ? [
          { key: 'aara-purple-gold-4', label: 'Model Wrist' },
          { key: 'aara-purple-4', label: 'Emerald Profile Rim' },
          { key: 'aara-purple-gold-2', label: 'Terracotta Arch' },
          { key: 'aara-purple-1', label: 'Baseline Frontal' }
        ] : [
          { key: 'aara-purple-4', label: 'Emerald Profile Rim' },
          { key: 'aara-purple-gold-2', label: 'Terracotta Arch' },
          { key: 'aara-purple-1', label: 'Baseline Frontal' },
          { key: 'aara-purple-gold-4', label: 'Model Wrist' }
        ];
      } else {
        return isBracelet ? [
          { key: 'aara-purple-gold-4', label: 'Model Wrist' },
          { key: 'aara-purple-1', label: 'Baseline Frontal' },
          { key: 'aara-purple-2', label: '45° Perspective' },
          { key: 'aara-purple-gold-1', label: 'Travertine Stone' }
        ] : [
          { key: 'aara-purple-1', label: 'Baseline Frontal' },
          { key: 'aara-purple-2', label: '45° Perspective' },
          { key: 'aara-purple-gold-1', label: 'Travertine Stone' },
          { key: 'aara-purple-gold-4', label: 'Model Wrist' }
        ];
      }
    } else {
      // Gold
      if (sid === 'yellow-sapphire') {
        return isBracelet ? [
          { key: 'aara-purple-gold-4', label: 'Model Wrist' },
          { key: 'aara-purple-gold-2', label: 'Yellow Sapphire Terracotta Arch' },
          { key: 'aara-purple-gold-5', label: 'Silk Drape' },
          { key: 'aara-purple-gold-1', label: 'Travertine Stone' },
          { key: 'aara-purple-gold-3', label: 'Crimson Velvet' }
        ] : [
          { key: 'aara-purple-gold-2', label: 'Yellow Sapphire Terracotta Arch' },
          { key: 'aara-purple-gold-1', label: 'Travertine Stone' },
          { key: 'aara-purple-gold-5', label: 'Silk Drape' },
          { key: 'aara-purple-gold-3', label: 'Crimson Velvet' },
          { key: 'aara-purple-gold-4', label: 'Model Wrist' }
        ];
      } else if (sid === 'amethyst') {
        return isBracelet ? [
          { key: 'aara-purple-gold-4', label: 'Model Wrist' },
          { key: 'aara-purple-gold-3', label: 'Oval Amethyst Crimson Velvet' },
          { key: 'aara-purple-gold-5', label: 'Silk Drape' },
          { key: 'aara-purple-gold-1', label: 'Travertine Stone' },
          { key: 'aara-purple-gold-2', label: 'Terracotta Arch' }
        ] : [
          { key: 'aara-purple-gold-3', label: 'Oval Amethyst Crimson Velvet' },
          { key: 'aara-purple-gold-5', label: 'Silk Drape' },
          { key: 'aara-purple-gold-1', label: 'Travertine Stone' },
          { key: 'aara-purple-gold-2', label: 'Terracotta Arch' },
          { key: 'aara-purple-gold-4', label: 'Model Wrist' }
        ];
      } else if (sid === 'emerald') {
        return isBracelet ? [
          { key: 'aara-purple-gold-4', label: 'Model Wrist' },
          { key: 'aara-purple-gold-2', label: 'Emerald Terracotta Arch' },
          { key: 'aara-purple-gold-5', label: 'Silk Drape' },
          { key: 'aara-purple-gold-1', label: 'Travertine Stone' },
          { key: 'aara-purple-gold-3', label: 'Crimson Velvet' }
        ] : [
          { key: 'aara-purple-gold-2', label: 'Emerald Terracotta Arch' },
          { key: 'aara-purple-gold-5', label: 'Silk Drape' },
          { key: 'aara-purple-gold-1', label: 'Travertine Stone' },
          { key: 'aara-purple-gold-3', label: 'Crimson Velvet' },
          { key: 'aara-purple-gold-4', label: 'Model Wrist' }
        ];
      } else if (sid === 'ruby') {
        return isBracelet ? [
          { key: 'aara-purple-gold-4', label: 'Model Wrist' },
          { key: 'aara-purple-gold-3', label: 'Crimson Velvet' },
          { key: 'aara-purple-gold-1', label: 'Travertine Stone' },
          { key: 'aara-purple-gold-5', label: 'Silk Drape' }
        ] : [
          { key: 'aara-purple-gold-3', label: 'Crimson Velvet' },
          { key: 'aara-purple-gold-1', label: 'Travertine Stone' },
          { key: 'aara-purple-gold-5', label: 'Silk Drape' },
          { key: 'aara-purple-gold-4', label: 'Model Wrist' }
        ];
      } else if (sid === 'blue-sapphire') {
        return isBracelet ? [
          { key: 'aara-purple-gold-4', label: 'Model Wrist' },
          { key: 'aara-purple-gold-1', label: 'Ceylon Sapphire Travertine' },
          { key: 'aara-purple-gold-3', label: 'Crimson Velvet' },
          { key: 'aara-purple-gold-5', label: 'Silk Drape' }
        ] : [
          { key: 'aara-purple-gold-1', label: 'Ceylon Sapphire Travertine' },
          { key: 'aara-purple-gold-3', label: 'Crimson Velvet' },
          { key: 'aara-purple-gold-5', label: 'Silk Drape' },
          { key: 'aara-purple-gold-4', label: 'Model Wrist' }
        ];
      } else {
        // diamond & defaults
        return isBracelet ? [
          { key: 'aara-purple-gold-4', label: 'Model Wrist' },
          { key: 'aara-purple-gold-5', label: 'Silk Drape' },
          { key: 'aara-purple-gold-1', label: 'Travertine Stone' },
          { key: 'aara-purple-gold-2', label: 'Terracotta Arch' },
          { key: 'aara-purple-gold-3', label: 'Crimson Velvet' }
        ] : [
          { key: 'aara-purple-gold-1', label: 'Travertine Stone' },
          { key: 'aara-purple-gold-2', label: 'Terracotta Arch' },
          { key: 'aara-purple-gold-3', label: 'Crimson Velvet' },
          { key: 'aara-purple-gold-4', label: 'Model Wrist' },
          { key: 'aara-purple-gold-5', label: 'Silk Drape' }
        ];
      }
    }
  }

  if (did === 'deu-blue') {
    if (isSilver) {
      if (sid === 'yellow-sapphire') {
        return isBracelet ? [
          { key: 'deu-blue-silver-4', label: 'Yellow Sapphire Ocean Pier' },
          { key: 'deu-blue-silver-5', label: 'Water Touch' },
          { key: 'deu-blue-silver-1', label: 'Sea Beach Sands' },
          { key: 'deu-blue-silver-3', label: 'Cobalt Caustics' }
        ] : [
          { key: 'deu-blue-silver-4', label: 'Yellow Sapphire Ocean Pier' },
          { key: 'deu-blue-silver-1', label: 'Sea Beach Sands' },
          { key: 'deu-blue-silver-3', label: 'Cobalt Caustics' },
          { key: 'deu-blue-silver-2', label: 'Moonlit Rock' },
          { key: 'deu-blue-silver-5', label: 'Water Touch' }
        ];
      } else if (sid === 'amethyst') {
        return isBracelet ? [
          { key: 'deu-blue-silver-4', label: 'Ocean Pier' },
          { key: 'deu-blue-silver-3', label: 'Amethyst Cobalt Caustics' },
          { key: 'deu-blue-silver-1', label: 'Sea Beach' },
          { key: 'deu-blue-silver-5', label: 'Water Touch' }
        ] : [
          { key: 'deu-blue-silver-3', label: 'Amethyst Cobalt Caustics' },
          { key: 'deu-blue-silver-1', label: 'Sea Beach' },
          { key: 'deu-blue-silver-2', label: 'Moonlit Rock' },
          { key: 'deu-blue-silver-4', label: 'Ocean Pier' },
          { key: 'deu-blue-silver-5', label: 'Water Touch' }
        ];
      } else if (sid === 'ruby') {
        return isBracelet ? [
          { key: 'deu-blue-silver-4', label: 'Ocean Pier' },
          { key: 'deu-blue-silver-2', label: 'Moonlit Rock Ruby' },
          { key: 'deu-blue-silver-1', label: 'Sea Beach' },
          { key: 'deu-blue-silver-5', label: 'Water Touch' }
        ] : [
          { key: 'deu-blue-silver-2', label: 'Moonlit Rock Ruby' },
          { key: 'deu-blue-silver-1', label: 'Sea Beach' },
          { key: 'deu-blue-silver-3', label: 'Cobalt Caustics' },
          { key: 'deu-blue-silver-4', label: 'Ocean Pier' },
          { key: 'deu-blue-silver-5', label: 'Water Touch' }
        ];
      } else {
        // blue-sapphire, diamond & default
        return isBracelet ? [
          { key: 'deu-blue-silver-4', label: 'Ocean Pier' },
          { key: 'deu-blue-silver-5', label: 'Water Touch' },
          { key: 'deu-blue-silver-1', label: 'Sea Beach' },
          { key: 'deu-blue-silver-3', label: 'Cobalt Caustics' },
          { key: 'deu-blue-silver-2', label: 'Moonlit Rock' }
        ] : [
          { key: 'deu-blue-silver-1', label: 'Sea Beach' },
          { key: 'deu-blue-silver-3', label: 'Cobalt Caustics' },
          { key: 'deu-blue-silver-2', label: 'Moonlit Rock' },
          { key: 'deu-blue-silver-4', label: 'Ocean Pier' },
          { key: 'deu-blue-silver-5', label: 'Water Touch' }
        ];
      }
    } else {
      // Gold
      if (sid === 'yellow-sapphire') {
        return isBracelet ? [
          { key: 'deu-blue-silver-4', label: 'Yellow Sapphire Ocean Pier' },
          { key: 'deu-blue-gold-2', label: 'Yellow Sapphire Storm Crystal' },
          { key: 'deu-blue-gold-1', label: 'Glacial Gold' },
          { key: 'deu-blue-silver-3', label: 'Cobalt Caustics' }
        ] : [
          { key: 'deu-blue-gold-2', label: 'Yellow Sapphire Storm Crystal' },
          { key: 'deu-blue-gold-1', label: 'Glacial Gold' },
          { key: 'deu-blue-silver-3', label: 'Cobalt Caustics' },
          { key: 'deu-blue-silver-4', label: 'Ocean Pier' }
        ];
      } else if (sid === 'amethyst') {
        return isBracelet ? [
          { key: 'deu-blue-silver-4', label: 'Ocean Pier' },
          { key: 'deu-blue-gold-2', label: 'Amethyst Clay Pedestal' },
          { key: 'deu-blue-gold-1', label: 'Glacial Gold' },
          { key: 'deu-blue-silver-3', label: 'Cobalt Caustics' }
        ] : [
          { key: 'deu-blue-gold-2', label: 'Amethyst Clay Pedestal' },
          { key: 'deu-blue-gold-1', label: 'Glacial Gold' },
          { key: 'deu-blue-silver-3', label: 'Cobalt Caustics' },
          { key: 'deu-blue-silver-4', label: 'Ocean Pier' }
        ];
      } else if (sid === 'emerald') {
        return isBracelet ? [
          { key: 'deu-blue-silver-4', label: 'Ocean Pier' },
          { key: 'deu-blue-gold-1', label: 'Emerald Ocean Plate' },
          { key: 'deu-blue-gold-2', label: 'Sculptural Gold' },
          { key: 'deu-blue-silver-3', label: 'Cobalt Caustics' }
        ] : [
          { key: 'deu-blue-gold-1', label: 'Emerald Ocean Plate' },
          { key: 'deu-blue-gold-2', label: 'Sculptural Gold' },
          { key: 'deu-blue-silver-3', label: 'Cobalt Caustics' },
          { key: 'deu-blue-silver-4', label: 'Ocean Pier' }
        ];
      } else {
        // blue-sapphire, diamond & defaults
        return isBracelet ? [
          { key: 'deu-blue-silver-4', label: 'Ocean Pier' },
          { key: 'deu-blue-gold-1', label: 'Glacial Gold' },
          { key: 'deu-blue-gold-2', label: 'Sculptural Gold' },
          { key: 'deu-blue-silver-3', label: 'Cobalt Caustics' }
        ] : [
          { key: 'deu-blue-gold-1', label: 'Glacial Gold' },
          { key: 'deu-blue-gold-2', label: 'Sculptural Gold' },
          { key: 'deu-blue-silver-3', label: 'Cobalt Caustics' },
          { key: 'deu-blue-silver-4', label: 'Ocean Pier' }
        ];
      }
    }
  }

  if (did === 'deu-green') {
    if (isSilver) {
      if (sid === 'diamond') {
        return isBracelet ? [
          { key: 'deu-green-gold-5', label: 'Clover Wrist' },
          { key: 'deu-green-2', label: 'Diamond Pedestal Angle' },
          { key: 'deu-green-gold-2', label: 'Botanical Shade' },
          { key: 'deu-green-1', label: 'Baseline Frontal' }
        ] : [
          { key: 'deu-green-2', label: 'Diamond Pedestal Angle' },
          { key: 'deu-green-gold-2', label: 'Botanical Shade' },
          { key: 'deu-green-1', label: 'Baseline Frontal' },
          { key: 'deu-green-gold-5', label: 'Clover Wrist' }
        ];
      } else if (sid === 'amethyst') {
        return isBracelet ? [
          { key: 'deu-green-gold-5', label: 'Clover Wrist' },
          { key: 'deu-green-3', label: 'Amethyst Macro Bezel' },
          { key: 'deu-green-gold-3', label: 'Mossy Driftwood' },
          { key: 'deu-green-1', label: 'Baseline Frontal' }
        ] : [
          { key: 'deu-green-3', label: 'Amethyst Macro Bezel' },
          { key: 'deu-green-gold-3', label: 'Mossy Driftwood' },
          { key: 'deu-green-1', label: 'Baseline Frontal' },
          { key: 'deu-green-gold-5', label: 'Clover Wrist' }
        ];
      } else if (sid === 'yellow-sapphire') {
        return isBracelet ? [
          { key: 'deu-green-gold-5', label: 'Clover Wrist' },
          { key: 'deu-green-4', label: 'Yellow Sapphire Profile Rim' },
          { key: 'deu-green-gold-4', label: 'Field Breeze' },
          { key: 'deu-green-1', label: 'Baseline Frontal' }
        ] : [
          { key: 'deu-green-4', label: 'Yellow Sapphire Profile Rim' },
          { key: 'deu-green-gold-4', label: 'Field Breeze' },
          { key: 'deu-green-1', label: 'Baseline Frontal' },
          { key: 'deu-green-gold-5', label: 'Clover Wrist' }
        ];
      } else {
        return isBracelet ? [
          { key: 'deu-green-gold-5', label: 'Clover Wrist' },
          { key: 'deu-green-1', label: 'Baseline Frontal' },
          { key: 'deu-green-2', label: '45° Perspective' },
          { key: 'deu-green-gold-1', label: 'Raw Linen' }
        ] : [
          { key: 'deu-green-1', label: 'Baseline Frontal' },
          { key: 'deu-green-2', label: '45° Perspective' },
          { key: 'deu-green-gold-1', label: 'Raw Linen' },
          { key: 'deu-green-gold-5', label: 'Clover Wrist' }
        ];
      }
    } else {
      // Gold
      if (sid === 'diamond') {
        return isBracelet ? [
          { key: 'deu-green-gold-5', label: 'Clover Wrist' },
          { key: 'deu-green-gold-2', label: 'Diamond Botanical Shade' },
          { key: 'deu-green-gold-1', label: 'Raw Linen' },
          { key: 'deu-green-gold-4', label: 'Field Breeze' }
        ] : [
          { key: 'deu-green-gold-2', label: 'Diamond Botanical Shade' },
          { key: 'deu-green-gold-1', label: 'Raw Linen' },
          { key: 'deu-green-gold-3', label: 'Mossy Driftwood' },
          { key: 'deu-green-gold-4', label: 'Field Breeze' },
          { key: 'deu-green-gold-5', label: 'Clover Wrist' }
        ];
      } else if (sid === 'amethyst') {
        return isBracelet ? [
          { key: 'deu-green-gold-5', label: 'Clover Wrist' },
          { key: 'deu-green-gold-3', label: 'Amethyst Mossy Driftwood' },
          { key: 'deu-green-gold-1', label: 'Raw Linen' },
          { key: 'deu-green-gold-4', label: 'Field Breeze' }
        ] : [
          { key: 'deu-green-gold-3', label: 'Amethyst Mossy Driftwood' },
          { key: 'deu-green-gold-1', label: 'Raw Linen' },
          { key: 'deu-green-gold-2', label: 'Botanical Shade' },
          { key: 'deu-green-gold-4', label: 'Field Breeze' },
          { key: 'deu-green-gold-5', label: 'Clover Wrist' }
        ];
      } else if (sid === 'yellow-sapphire') {
        return isBracelet ? [
          { key: 'deu-green-gold-5', label: 'Clover Wrist' },
          { key: 'deu-green-gold-4', label: 'Yellow Sapphire Field Breeze' },
          { key: 'deu-green-gold-1', label: 'Raw Linen' },
          { key: 'deu-green-gold-2', label: 'Botanical Shade' }
        ] : [
          { key: 'deu-green-gold-4', label: 'Yellow Sapphire Field Breeze' },
          { key: 'deu-green-gold-1', label: 'Raw Linen' },
          { key: 'deu-green-gold-2', label: 'Botanical Shade' },
          { key: 'deu-green-gold-3', label: 'Mossy Driftwood' },
          { key: 'deu-green-gold-5', label: 'Clover Wrist' }
        ];
      } else if (sid === 'ruby') {
        return isBracelet ? [
          { key: 'deu-green-gold-5', label: 'Clover Wrist' },
          { key: 'deu-green-gold-3', label: 'Ruby Mossy Driftwood' },
          { key: 'deu-green-gold-1', label: 'Raw Linen' },
          { key: 'deu-green-gold-4', label: 'Field Breeze' }
        ] : [
          { key: 'deu-green-gold-3', label: 'Ruby Mossy Driftwood' },
          { key: 'deu-green-gold-1', label: 'Raw Linen' },
          { key: 'deu-green-gold-4', label: 'Field Breeze' },
          { key: 'deu-green-gold-5', label: 'Clover Wrist' }
        ];
      } else if (sid === 'blue-sapphire') {
        return isBracelet ? [
          { key: 'deu-green-gold-5', label: 'Clover Wrist' },
          { key: 'deu-green-gold-4', label: 'Field Breeze' },
          { key: 'deu-green-gold-1', label: 'Raw Linen' },
          { key: 'deu-green-gold-3', label: 'Mossy Driftwood' }
        ] : [
          { key: 'deu-green-gold-4', label: 'Field Breeze' },
          { key: 'deu-green-gold-1', label: 'Raw Linen' },
          { key: 'deu-green-gold-3', label: 'Mossy Driftwood' },
          { key: 'deu-green-gold-5', label: 'Clover Wrist' }
        ];
      } else {
        // emerald & defaults
        return isBracelet ? [
          { key: 'deu-green-gold-5', label: 'Clover Wrist' },
          { key: 'deu-green-gold-1', label: 'Raw Linen' },
          { key: 'deu-green-gold-2', label: 'Botanical Shade' },
          { key: 'deu-green-gold-3', label: 'Mossy Driftwood' },
          { key: 'deu-green-gold-4', label: 'Field Breeze' }
        ] : [
          { key: 'deu-green-gold-1', label: 'Raw Linen' },
          { key: 'deu-green-gold-2', label: 'Botanical Shade' },
          { key: 'deu-green-gold-3', label: 'Mossy Driftwood' },
          { key: 'deu-green-gold-4', label: 'Field Breeze' },
          { key: 'deu-green-gold-5', label: 'Clover Wrist' }
        ];
      }
    }
  }

  // Fallback for custom or unknown designs:
  var fallbackDesign = dObj || design(did) || design(designId);
  if (fallbackDesign && fallbackDesign.photos && fallbackDesign.photos.length > 0) {
    return fallbackDesign.photos.map(function(pKey, i) {
      return { key: pKey, label: 'Studio Angle ' + (i + 1) };
    });
  }

  return [];
}

var currentGalleryIndex = 0;

function switchGallery(idx){
  currentGalleryIndex = idx;
  var d=design(pstate.designId),m=mById(pstate.metal),s=sById(pstate.stone);
  if(!d) d = DESIGNS[0];
  if(!m) m = METALS[4];
  if(!s) s = STONES[0];
  var photos = getCustomizedPhotos(pstate.designId, pstate.metal, pstate.type, pstate.stone);
  var assets = (typeof window !== 'undefined' && window.ASTR_ASSETS) ? window.ASTR_ASSETS : {};
  var validPhotos = photos.filter(function(item){ return !!assets[item.key]; });
  var artEl = (typeof document !== 'undefined') ? document.getElementById('pdArt') : null;
  var photoEl = (typeof document !== 'undefined') ? document.getElementById('pdPhoto') : null;
  var thumbs = (typeof document !== 'undefined') ? document.querySelectorAll('#pdThumbs .thumb-btn') : [];
  var metalColor = (m && m.kind==='silver') ? '#dcdfe3' : (pstate.metal==='rose' ? '#e5a88c' : (m.sw || '#d4af37'));

  if(thumbs && thumbs.length > 0){
    Array.prototype.forEach.call(thumbs,function(b,i){
      b.classList.toggle('active', (idx===-1 && i===thumbs.length-1) || (idx===i));
    });
  }

  if(idx===-1 || !validPhotos || !validPhotos[idx] || !assets[validPhotos[idx].key]){
    if(artEl) {
      artEl.style.display='block';
      artEl.innerHTML=ringArt(d.rings,d.color,s.color,metalColor);
    }
    if(photoEl) photoEl.style.display='none';
  } else {
    if(artEl) artEl.style.display='none';
    if(photoEl){
      photoEl.style.display='block';
      photoEl.onerror = function() {
        photoEl.style.display = 'none';
        if (artEl) {
          artEl.style.display = 'block';
          artEl.innerHTML = ringArt(d.rings, d.color, s.color, metalColor);
        }
      };
      photoEl.src=assets[validPhotos[idx].key] || '';
      photoEl.alt=validPhotos[idx].label + ' — ' + d.name + ' (' + s.name + ')';
    }
  }
  updateViz();
}

function renderProductGallery(keepIndex){
  var d=design(pstate.designId),m=mById(pstate.metal),s=sById(pstate.stone);
  if(!d) d = DESIGNS[0];
  if(!m) m = METALS[4];
  if(!s) s = STONES[0];
  var photos = getCustomizedPhotos(pstate.designId, pstate.metal, pstate.type, pstate.stone);
  var thumbsEl = (typeof document !== 'undefined') ? document.getElementById('pdThumbs') : null;
  var assets = (typeof window !== 'undefined' && window.ASTR_ASSETS) ? window.ASTR_ASSETS : {};
  var metalColor = (m && m.kind==='silver') ? '#dcdfe3' : (pstate.metal==='rose' ? '#e5a88c' : (m.sw || '#d4af37'));

  var validPhotos = photos.filter(function(item){ return !!assets[item.key]; });
  var hasExactPhoto = validPhotos.length > 0;

  if(thumbsEl){
    if(hasExactPhoto){
      var thumbsHtml = validPhotos.map(function(item, idx){
        var src = assets[item.key] || '';
        return '<button class="thumb-btn" onclick="switchGallery('+idx+')" title="'+item.label+' ('+s.name+')"><img src="'+src+'" alt="'+item.label+'"></button>';
      }).join('');
      thumbsHtml += '<button class="thumb-btn" onclick="switchGallery(-1)" title="Interactive 3D Sacred Geometry"><svg viewBox="0 0 200 200">'+ringArt(d.rings,d.color,s.color,metalColor)+'</svg><span class="thumb-tag">3D</span></button>';
      thumbsEl.innerHTML = thumbsHtml;
      thumbsEl.style.display='flex';
      
      var activeIdx = (typeof keepIndex === 'number' && keepIndex >= 0 && keepIndex < validPhotos.length) ? keepIndex : 0;
      switchGallery(activeIdx);
    } else {
      thumbsEl.innerHTML = '<button class="thumb-btn active" onclick="switchGallery(-1)" title="Interactive 3D Sacred Geometry"><svg viewBox="0 0 200 200">'+ringArt(d.rings,d.color,s.color,metalColor)+'</svg><span class="thumb-tag">3D</span></button>';
      thumbsEl.style.display='flex';
      switchGallery(-1);
    }
  }
}

function renderProduct(){
  var d=design(pstate.designId),m=mById(pstate.metal),s=sById(pstate.stone),c=calcFor(pstate.metal,pstate.stone);
  if(!d) d = DESIGNS[0];
  if(!m) m = METALS[4];
  if(!s) s = STONES[0];
  var backPage = d.shape === 'AARA' ? 'aara' : 'deu';
  var backLabel = d.shape === 'AARA' ? 'AARA Collection' : 'DEU Collection';
  var crumbEl = (typeof document !== 'undefined') ? document.getElementById('pdCrumb') : null;
  if(crumbEl) {
    crumbEl.textContent='← Back to ' + backLabel;
    crumbEl.onclick=function(){go(backPage);};
  }
  var vizEl = (typeof document !== 'undefined') ? document.getElementById('pdViz') : null;
  if(vizEl) vizEl.style.background='radial-gradient(circle at 50% 38%,#fff,'+tint(d.color)+' 130%)';
  var badgeEl = (typeof document !== 'undefined') ? document.getElementById('pdBadge') : null;
  if(badgeEl) badgeEl.textContent=d.shape+' · '+(pstate.type==='necklace'?'Necklace':'Bracelet');
  var captEl = (typeof document !== 'undefined') ? document.getElementById('pdCapt') : null;
  if(captEl) captEl.textContent=d.capt;

  renderProductGallery(0);
  updateViz();

  var siblings=DESIGNS.filter(function(x){return x.shape===d.shape;});
  var mini=siblings.map(function(x){return '<span class="mtag'+(x.id===d.id?' on':'')+'" title="'+x.name+'" style="background:'+x.color+'" onclick="openProduct(\''+x.id+'\',\''+pstate.type+'\')"></span>';}).join('');
  var shapeSizes = (ELEMENT_SIZES && ELEMENT_SIZES[d.shape]) ? ELEMENT_SIZES[d.shape] : (ELEMENT_SIZES ? ELEMENT_SIZES.AARA : {Small:'17.5 mm',Big:'22 mm'});
  var elInfo="The scale of the element — "+shapeSizes.Small+" (Small) or "+shapeSizes.Big+" (Big). Same price for both.";
  var typeSizes = (SIZES && SIZES[pstate.type]) ? SIZES[pstate.type] : (SIZES ? SIZES.necklace : ["16 in","18 in","20 in","22 in","24 in"]);
  var sizeInfoText = (SIZE_INFO && SIZE_INFO[pstate.type]) ? SIZE_INFO[pstate.type] : "Chain length around the neck.";
  var curObj = (typeof CURRENCIES !== 'undefined' && CURRENCIES[currentCurrency]) ? CURRENCIES[currentCurrency] : (typeof CURRENCIES !== 'undefined' && CURRENCIES.INR ? CURRENCIES.INR : { symbol: '₹', code: 'INR' });
  var html=
    '<span class="eyebrow">Personalise · '+d.role+'</span><h1>'+d.name+'</h1><div class="subtitle">'+d.element+' · '+(pstate.type==='necklace'?'Necklace':'Bracelet')+'</div>'+
    '<div class="opt"><div class="label">Piece Format '+infoBtn("Select whether you want this master design crafted as a necklace or an everyday bracelet.")+'<span class="cur" id="curType">'+(pstate.type==='necklace'?'Necklace':'Bracelet')+'</span></div><div class="choices" id="cType">'+
      chip("Necklace", pstate.type==='necklace', 'type', 'necklace')+
      chip("Bracelet", pstate.type==='bracelet', 'type', 'bracelet')+
    '</div></div>'+
    '<div class="opt"><div class="label">Colour · Element '+infoBtn("This design's element. Explore the other colours in the same shape.")+'<span class="cur">'+d.element+'</span></div><div class="miniswitch">'+mini+'</div></div>'+
    '<div class="opt"><div class="label">Metal &amp; Purity '+infoBtn("Metal changes the price and aesthetic finish. Gold scales by purity; silver is a fixed finish price.")+'<span class="cur" id="curMetal">'+m.name+'</span></div><div class="choices" id="cMetal">'+METALS.map(function(x){return chip(x.name,pstate.metal===x.id,'metal',x.id,x.sw);}).join('')+'</div></div>'+
    '<div class="opt"><div class="label">Stone '+infoBtn("Your crystal heart — each stone changes the price and carries its own energy.")+'<span class="cur" id="curStone">'+s.name+'</span></div><div class="choices" id="cStone">'+STONES.map(function(x){return chip(x.name,pstate.stone===x.id,'stone',x.id,x.color);}).join('')+'</div></div>'+
    '<div class="opt"><div class="label" id="cSizeLabel">'+(pstate.type==='necklace'?'Chain Length':'Bracelet Size')+' '+infoBtn(sizeInfoText)+'<span class="cur" id="curSize">'+(pstate.size||typeSizes[1]||typeSizes[0])+'</span></div><div class="choices" id="cSize">'+typeSizes.map(function(z){return chip(z,pstate.size===z,'size',z);}).join('')+'</div></div>'+
    '<div class="opt"><div class="label">Element Size '+infoBtn(elInfo)+'<span class="cur" id="curEl">'+(pstate.elSize||'Small')+'</span></div><div class="choices" id="cEl">'+["Small","Big"].map(function(z){return chip(z+' · '+shapeSizes[z],pstate.elSize===z,'elSize',z);}).join('')+'</div></div>'+
    '<div class="pricebox"><div class="now"><span class="cur" id="pCur">'+curObj.symbol+'</span><span id="pNow">'+formatMoney(c.total, false)+'</span></div><div class="live"><span class="dot"></span> Price moves with metal &amp; stone · incl. GST / Taxes</div><div class="bd" id="pBd"></div></div>'+
    '<div class="cfg-cta-group" style="display:flex;flex-direction:column;gap:10px;margin-top:16px">'+
      '<button id="addToBagBtn" class="btn btn-gold" style="width:100%;justify-content:center;padding:17px 24px;font-size:.82rem" onclick="addToBag()"><span class="t">Add to Sacred Bag</span> <span class="arrow">→</span></button>'+
      '<button class="btn btn-ghost" style="width:100%;justify-content:center;padding:12px 20px;font-size:.72rem" onclick="enquire()"><span class="t">Bespoke Concierge Request</span> <span class="arrow">↗</span></button>'+
    '</div>'+
    '<div class="pd-packaging-card" onclick="nav(\'packaging\')" role="button" tabindex="0" title="Learn about our signature keepsake gift packaging">'+
      '<div class="pd-pkg-icon">🎁</div>'+
      '<div class="pd-pkg-info">'+
        '<strong>Our Signature Gift Wrapping &amp; Keepsake Box</strong>'+
        '<span>Hand-tied ribbon, micro-suede sanctuary &amp; wax-sealed blessing card. <u style="color:var(--gold-deep)">Explore Packaging &rarr;</u></span>'+
      '</div>'+
    '</div>'+
    '<div class="summary" id="pSummary"></div>'+
    '<div class="ph">Placeholder pricing — stone add-ons, silver-finish costs, gold weight and making % are indicative until Preeti\'s costing sheet is filled. Sizes never change price.</div>';
  var panelEl = (typeof document !== 'undefined') ? document.getElementById('pdPanel') : null;
  if(panelEl) {
    panelEl.innerHTML=html;
    bindProduct();
    updatePrice(false);
  }
}

function bindProduct(){
  if (typeof document === 'undefined') return;
  Array.prototype.forEach.call(document.querySelectorAll('#pdPanel .chip[data-g]'),function(b){
    var g=b.getAttribute('data-g'),v=b.getAttribute('data-v');
    b.addEventListener('click',function(){
      pstate[g]=v;
      if(g==='metal'||g==='type'||g==='stone'){
        renderProductGallery(0);
      }
      commitChip(g);
    });
    if(g==='metal'||g==='stone'){
      b.addEventListener('mouseenter',function(){previewPrice(g,v);previewViz(g,v);});
      b.addEventListener('mouseleave',function(){updatePrice(true);updateViz();});
    }
  });
  var grSlider = document.getElementById('grSlider');
  if (grSlider) {
    grSlider.addEventListener('input', function() {
      goldRate = +this.value;
      var grVal = document.getElementById('grVal');
      if (grVal) grVal.textContent = formatMoney(goldRate) + '/g';
      updateRateTag();
      updatePrice(true);
    });
  }
}

function commitChip(g){
  var d=design(pstate.designId) || DESIGNS[0];
  if(g==='type'){
    var typeSizes = (SIZES && SIZES[pstate.type]) ? SIZES[pstate.type] : (SIZES ? SIZES.necklace : ["16 in","18 in","20 in","22 in","24 in"]);
    pstate.size = typeSizes[1] || typeSizes[0];
    if (typeof document !== 'undefined') {
      var curTypeEl = document.getElementById('curType');
      if (curTypeEl) curTypeEl.textContent = pstate.type==='necklace'?'Necklace':'Bracelet';
      var cSizeLabelEl = document.getElementById('cSizeLabel');
      if (cSizeLabelEl) cSizeLabelEl.innerHTML = (pstate.type==='necklace'?'Chain Length':'Bracelet Size') + ' ' + infoBtn(SIZE_INFO[pstate.type] || '') + '<span class="cur" id="curSize">' + pstate.size + '</span>';
      var cSizeEl = document.getElementById('cSize');
      if (cSizeEl) {
        cSizeEl.innerHTML = typeSizes.map(function(z){ return chip(z, pstate.size===z, 'size', z); }).join('');
        Array.prototype.forEach.call(document.querySelectorAll('#cSize .chip[data-g]'), function(b){
          b.addEventListener('click', function(){ pstate.size = b.getAttribute('data-v'); commitChip('size'); });
        });
      }
      var pdBadgeEl = document.getElementById('pdBadge');
      if (pdBadgeEl) pdBadgeEl.textContent = d.shape+' · '+(pstate.type==='necklace'?'Necklace':'Bracelet');
    }
  }
  if (typeof document !== 'undefined') {
    var map={type:'cType',metal:'cMetal',stone:'cStone',size:'cSize',elSize:'cEl'};
    var cont=document.getElementById(map[g]);
    if(cont){
      Array.prototype.forEach.call(cont.querySelectorAll('.chip'),function(x){x.classList.toggle('active',x.getAttribute('data-v')===pstate[g]);});
    }
    var curMetalEl = document.getElementById('curMetal');
    if(g==='metal' && curMetalEl) {
      var m = mById(pstate.metal) || METALS[4];
      curMetalEl.textContent = m.name;
    }
    var curStoneEl = document.getElementById('curStone');
    if(g==='stone' && curStoneEl) {
      var s = sById(pstate.stone) || STONES[0];
      curStoneEl.textContent = s.name;
    }
    var curSizeEl = document.getElementById('curSize');
    if(g==='size' && curSizeEl) curSizeEl.textContent=pstate.size;
    var curElEl = document.getElementById('curEl');
    if(g==='elSize' && curElEl) curElEl.textContent=pstate.elSize;
  }
  updatePrice(true); updateViz();
}

function previewPrice(g,v){
  var mid=g==='metal'?v:pstate.metal,sid=g==='stone'?v:pstate.stone;
  setPrice(calcFor(mid,sid),mid,sid);
}

function updatePrice(animate){
  var c=calcFor(pstate.metal,pstate.stone);
  setPrice(c,pstate.metal,pstate.stone,animate);
  var d=design(pstate.designId) || DESIGNS[0];
  var m=mById(pstate.metal) || METALS[4];
  var s=sById(pstate.stone) || STONES[0];
  if (typeof document !== 'undefined') {
    var pSumEl = document.getElementById('pSummary');
    if (pSumEl) {
      pSumEl.innerHTML='Your piece: <b>'+d.name+'</b> ('+(pstate.type==='necklace'?'Necklace':'Bracelet')+') · <b>'+m.name+'</b> · <b>'+s.name+'</b> · '+(pstate.size||'18 in')+' · '+(pstate.elSize||'Small')+' element.';
    }
  }
}

function setPrice(c,mid,sid,animate){
  var cur = (typeof CURRENCIES !== 'undefined' && CURRENCIES[currentCurrency]) ? CURRENCIES[currentCurrency] : (typeof CURRENCIES !== 'undefined' && CURRENCIES.INR ? CURRENCIES.INR : { symbol: '₹', code: 'INR', locale: 'en-IN' });
  if (typeof document !== 'undefined') {
    var pCur = document.getElementById('pCur');
    if(pCur) pCur.textContent = cur.symbol;
    var targetVal = getConvertedValue(c.total);
    countTo(document.getElementById('pNow'), targetVal, animate!==false);
    var m=mById(mid) || METALS[4];
    var s=sById(sid) || STONES[0];
    var metalLine=(m.kind==='silver')?m.name+' · Hallmarked 925':m.name+' · '+Math.round(((PURITY && PURITY[m.id]) || 0.75)*100)+'% Hallmarked Gold';
    var pBdEl = document.getElementById('pBd');
    if (pBdEl) {
      pBdEl.innerHTML=
        '<div class="row"><span>'+metalLine+'</span><span class="v">'+formatMoney(c.metal)+'</span></div>'+
        '<div class="row"><span>Artisanal Making ('+Math.round(MAKING*100)+'%)</span><span class="v">'+formatMoney(c.making)+'</span></div>'+
        '<div class="row"><span>'+s.name+' Gemstone</span><span class="v">'+formatMoney(c.stone)+'</span></div>'+
        '<div class="row"><span>GST / Taxes (3%)</span><span class="v">'+formatMoney(c.gst)+'</span></div>'+
        '<div class="row tot"><span>Total ('+cur.code+')</span><span class="v">'+formatMoney(c.total)+'</span></div>';
    }
  }
}

function previewViz(g,v){
  var d=design(pstate.designId) || DESIGNS[0];
  var mid=g==='metal'?v:pstate.metal;
  var sid=g==='stone'?v:pstate.stone;
  var m=mById(mid) || METALS[4];
  var s=sById(sid) || STONES[0];
  var metalColor = (m && m.kind==='silver') ? '#dcdfe3' : (mid==='rose' ? '#e5a88c' : (m.sw || '#d4af37'));
  if (typeof document !== 'undefined') {
    var artEl=document.getElementById('pdArt');
    if(artEl) artEl.innerHTML=ringArt(d.rings,d.color,s.color,metalColor);
    var badgeEl=document.getElementById('pdStoneBadge');
    if(badgeEl) badgeEl.innerHTML='<span class="sw" style="background:'+s.color+';color:'+s.color+'"></span> Core: '+s.name;
  }
}

function updateViz(){
  var d=design(pstate.designId) || DESIGNS[0];
  var m=mById(pstate.metal) || METALS[4];
  var s=sById(pstate.stone) || STONES[0];
  var metalColor = (m && m.kind==='silver') ? '#dcdfe3' : (pstate.metal==='rose' ? '#e5a88c' : (m.sw || '#d4af37'));
  if (typeof document !== 'undefined') {
    var artEl=document.getElementById('pdArt');
    if(artEl) artEl.innerHTML=ringArt(d.rings,d.color,s.color,metalColor);
    var badgeEl=document.getElementById('pdStoneBadge');
    if(badgeEl) badgeEl.innerHTML='<span class="sw" style="background:'+s.color+';color:'+s.color+'"></span> Core: '+s.name;
  }
}
/* count-up */
function countTo(el,target,animate){
  if(!el) return;
  var curLocale = (typeof CURRENCIES !== 'undefined' && CURRENCIES[currentCurrency]) ? CURRENCIES[currentCurrency].locale : 'en-IN';
  var cur=parseInt((el.textContent||'0').replace(/[^0-9]/g,''))||0;
  if(!animate || typeof requestAnimationFrame === 'undefined'){
    el.textContent=Number(target).toLocaleString(curLocale);
    return;
  }
  var start=cur,diff=target-start,t0=null,dur=520;
  function step(ts){
    if(!t0)t0=ts;
    var p=Math.min((ts-t0)/dur,1);
    var e=1-Math.pow(1-p,3);
    el.textContent=Number(Math.round(start+diff*e)).toLocaleString(curLocale);
    if(p<1 && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}
function toggleTip(el,e){e.stopPropagation();var open=el.classList.contains('open');if(typeof document!=='undefined'){Array.prototype.forEach.call(document.querySelectorAll('.info.open'),function(i){i.classList.remove('open');});}if(!open)el.classList.add('open');}
if (typeof document !== 'undefined') {
  document.addEventListener('click',function(){Array.prototype.forEach.call(document.querySelectorAll('.info.open'),function(i){i.classList.remove('open');});});
}

/* ================= STONES ================= */
function renderStones(){
  if (typeof document === 'undefined') return;
  var el = document.getElementById('stoneCards');
  var assets = (typeof window !== 'undefined' && window.ASTR_ASSETS) ? window.ASTR_ASSETS : {};
  if (el) {
    el.innerHTML=STONES.map(function(s){
      var imgSrc = assets['gem-' + s.id];
      var imgHtml = imgSrc
        ? '<div class="stone-photo"><img src="'+imgSrc+'" alt="'+s.name+'" loading="lazy"></div>'
        : '';
      return '<div class="stone reveal in">' +
        imgHtml +
        '<div class="top"><span class="gem" style="background:'+s.color+'"></span><div><h4>'+s.name+'</h4><div class="alt">'+s.alt+'</div></div></div>' +
        '<p>'+s.info+'</p></div>';
    }).join('');
  }
  setTimeout(function(){ observeReveals(); bindTilt(); }, 10);
}

/* ================= TRY-ON & AI COMPUTER VISION ================= */
var tryStream = null;
var poseLandmarker = null;
var isVisionLoading = false;
var autoTrackEnabled = true;
var poseAnimFrame = null;
var lastVideoTime = -1;
var isDraggingTryOn = false;
var smoothX = null, smoothY = null, smoothSize = null, smoothRot = null;
var LERP_FACTOR = 0.28;

function loadMediaPipeTasks(callback) {
  if (poseLandmarker) {
    if (callback) callback(poseLandmarker);
    return;
  }
  if (isVisionLoading) {
    var checkInterval = setInterval(function() {
      if (poseLandmarker) {
        clearInterval(checkInterval);
        if (callback) callback(poseLandmarker);
      }
    }, 100);
    return;
  }
  isVisionLoading = true;
  var trackBadge = document.getElementById('tryTrackBadge');
  var trackText = document.getElementById('tryTrackText');
  if (trackBadge) trackBadge.style.display = 'flex';
  if (trackText) trackText.textContent = 'Loading AI Vision…';

  import("https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14/wasm/vision_bundle.mjs")
    .then(function(vision) {
      return vision.FilesetResolver.forVisionTasks(
        "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14/wasm"
      ).then(function(fileset) {
        return vision.PoseLandmarker.createFromOptions(fileset, {
          baseOptions: {
            modelAssetPath: "https://storage.googleapis.com/mediapipe-models/pose_landmarker/pose_landmarker_lite/float16/1/pose_landmarker_lite.task",
            delegate: "GPU"
          },
          runningMode: "VIDEO",
          numPoses: 1
        });
      });
    })
    .then(function(landmarker) {
      poseLandmarker = landmarker;
      isVisionLoading = false;
      if (trackText) trackText.textContent = 'AI Tracking Active ✨';
      if (callback) callback(poseLandmarker);
    })
    .catch(function(err) {
      console.warn('MediaPipe vision initialization fallback to manual:', err);
      isVisionLoading = false;
      if (trackText) trackText.textContent = 'Manual Mode';
    });
}

function processPoseFrame() {
  if (!tryStream) return;
  var video = document.getElementById('tryVideo');
  var ov = document.getElementById('tryOverlay');
  var stage = document.getElementById('tryStage');
  var trackText = document.getElementById('tryTrackText');
  var trackBadge = document.getElementById('tryTrackBadge');

  if (autoTrackEnabled && !isDraggingTryOn && poseLandmarker && video && video.readyState >= 2) {
    if (video.currentTime !== lastVideoTime) {
      lastVideoTime = video.currentTime;
      var startTimeMs = performance.now();
      try {
        var results = poseLandmarker.detectForVideo(video, startTimeMs);
        if (results && results.landmarks && results.landmarks.length > 0) {
          var marks = results.landmarks[0];
          var stageW = stage.clientWidth;
          var stageH = stage.clientHeight;
          var isBracelet = pstate && pstate.type === 'bracelet';

          if (isBracelet) {
            var lw = marks[15], rw = marks[16];
            var wrist = (lw && lw.visibility > 0.4) ? lw : ((rw && rw.visibility > 0.4) ? rw : null);
            if (wrist) {
              var targetX = (1 - wrist.x) * stageW;
              var targetY = wrist.y * stageH;
              var targetSize = Math.max(70, Math.min(220, stageW * 0.24));
              var targetRot = 0;
              applySmoothPlacement(targetX, targetY, targetSize, targetRot);
              if (trackBadge) trackBadge.style.display = 'flex';
              if (trackText) trackText.textContent = 'Wrist Detected ✨';
            }
          } else {
            var ls = marks[11], rs = marks[12];
            if (ls && rs && (ls.visibility > 0.25 || rs.visibility > 0.25)) {
              var scrLeftX = (1 - ls.x) * stageW;
              var scrRightX = (1 - rs.x) * stageW;
              var scrLeftY = ls.y * stageH;
              var scrRightY = rs.y * stageH;

              var midX = (scrLeftX + scrRightX) / 2;
              var midY = (scrLeftY + scrRightY) / 2;
              var span = Math.hypot(scrRightX - scrLeftX, scrRightY - scrLeftY);
              var dropFactor = (pstate && pstate.size) ? (parseInt(pstate.size) || 18) / 18 : 1.0;
              var targetX = midX;
              var targetY = midY + (span * 0.14 * dropFactor);
              var targetSize = Math.max(70, Math.min(300, span * 0.52 * (pstate && pstate.elSize === 'Big' ? 1.18 : 1.0)));
              var targetRot = Math.atan2(scrRightY - scrLeftY, scrRightX - scrLeftX) * (180 / Math.PI);

              applySmoothPlacement(targetX, targetY, targetSize, targetRot);
              if (trackBadge) trackBadge.style.display = 'flex';
              if (trackText) trackText.textContent = 'Neck & Collarbone ✨';
            }
          }
        }
      } catch (e) {
        // Continue loop gracefully
      }
    }
  }

  poseAnimFrame = requestAnimationFrame(processPoseFrame);
}

function applySmoothPlacement(targetX, targetY, targetSize, targetRot) {
  var ov = document.getElementById('tryOverlay');
  var sizeSlider = document.getElementById('trySize');
  var rotSlider = document.getElementById('tryRot');
  if (!ov) return;

  if (smoothX === null) {
    smoothX = targetX;
    smoothY = targetY;
    smoothSize = targetSize;
    smoothRot = targetRot;
  } else {
    smoothX += (targetX - smoothX) * LERP_FACTOR;
    smoothY += (targetY - smoothY) * LERP_FACTOR;
    smoothSize += (targetSize - smoothSize) * LERP_FACTOR;
    smoothRot += (targetRot - smoothRot) * LERP_FACTOR;
  }

  var s = Math.round(smoothSize);
  ov.style.left = Math.round(smoothX - s / 2) + 'px';
  ov.style.top = Math.round(smoothY - s / 2) + 'px';
  ov.style.width = s + 'px';
  ov.style.height = s + 'px';
  ov.style.transform = 'rotate(' + smoothRot.toFixed(1) + 'deg)';

  if (sizeSlider) sizeSlider.value = s;
  if (rotSlider) rotSlider.value = Math.round(smoothRot);
}

function toggleAutoTracking() {
  autoTrackEnabled = !autoTrackEnabled;
  var btnText = document.getElementById('tryToggleText');
  var trackBadge = document.getElementById('tryTrackBadge');
  var trackText = document.getElementById('tryTrackText');
  if (btnText) btnText.textContent = autoTrackEnabled ? 'Auto-Track: ON' : 'Auto-Track: OFF';
  if (!autoTrackEnabled) {
    if (trackText) trackText.textContent = 'Manual Mode';
  } else {
    smoothX = null; smoothY = null;
    if (trackText) trackText.textContent = 'Searching pose…';
  }
}

function openTryOn() {
  var d = design(pstate.designId) || DESIGNS[0], s = sById(pstate.stone) || STONES[0], m = mById(pstate.metal) || METALS[4];
  var metalColor = (m && m.kind === 'silver') ? '#dcdfe3' : (pstate.metal === 'rose' ? '#e5a88c' : (m.sw || '#d4af37'));
  if (typeof document !== 'undefined') {
    var tryOv = document.getElementById('tryOverlay');
    if (tryOv) tryOv.innerHTML = '<svg viewBox="0 0 200 200">' + ringArt(d.rings, d.color, s.color, metalColor) + '</svg>';
    var tryMod = document.getElementById('tryModal');
    if (tryMod) {
      tryMod.classList.add('open');
      if (typeof tryMod.removeAttribute === 'function') tryMod.removeAttribute('inert');
    }
  }
  startCam();
}

function startCam() {
  if (typeof document === 'undefined') return;
  var msg = document.getElementById('tryMsg'), ov = document.getElementById('tryOverlay'), v = document.getElementById('tryVideo');
  var trackBadge = document.getElementById('tryTrackBadge');
  if (msg) msg.textContent = 'Starting camera…';
  if (ov) ov.style.display = 'none';
  if (trackBadge) trackBadge.style.display = 'none';
  smoothX = null; smoothY = null; smoothSize = null; smoothRot = null;

  if (typeof navigator === 'undefined' || !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
    if (msg) msg.textContent = 'Camera not supported here.';
    return;
  }

  navigator.mediaDevices.getUserMedia({
    video: { facingMode: 'user', width: { ideal: 640 }, height: { ideal: 480 } },
    audio: false
  }).then(function(stream) {
    tryStream = stream;
    if (v) {
      v.srcObject = stream;
      v.onloadedmetadata = function() {
        v.play();
        if (msg) msg.textContent = '';
        if (ov) {
          ov.style.display = 'block';
          var st = document.getElementById('tryStage');
          if (st) {
            ov.style.left = (st.clientWidth / 2 - 65) + 'px';
            ov.style.top = (st.clientHeight / 2 - 65) + 'px';
          }
        }

        loadMediaPipeTasks(function() {
          if (poseAnimFrame) cancelAnimationFrame(poseAnimFrame);
          poseAnimFrame = requestAnimationFrame(processPoseFrame);
        });
      };
    }
  }).catch(function() {
    if (msg) msg.textContent = 'Camera blocked. Allow permission, then Restart Camera.';
  });
}

function retryCam() {
  stopCam();
  startCam();
}

function stopCam() {
  if (poseAnimFrame && typeof cancelAnimationFrame === 'function') {
    cancelAnimationFrame(poseAnimFrame);
    poseAnimFrame = null;
  }
  if (tryStream && tryStream.getTracks) {
    tryStream.getTracks().forEach(function(t) { if (t && t.stop) t.stop(); });
    tryStream = null;
  }
  smoothX = null; smoothY = null; smoothSize = null; smoothRot = null;
  if (typeof document !== 'undefined') {
    var trackBadge = document.getElementById('tryTrackBadge');
    if (trackBadge) trackBadge.style.display = 'none';
  }
}

function closeTryOn() {
  if (typeof document !== 'undefined') {
    var tryMod = document.getElementById('tryModal');
    if (tryMod) {
      tryMod.classList.remove('open');
      if (typeof tryMod.setAttribute === 'function') tryMod.setAttribute('inert', '');
    }
  }
  stopCam();
}

if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  (function() {
    var ov = document.getElementById('tryOverlay'), ox = 0, oy = 0;
    if (!ov) return;
    function pt(e) {
      var st = document.getElementById('tryStage');
      if (!st) return { x: 0, y: 0 };
      var r = st.getBoundingClientRect();
      var t = e.touches ? e.touches[0] : e;
      return { x: t.clientX - r.left, y: t.clientY - r.top };
    }
    function down(e) {
      isDraggingTryOn = true;
      var p = pt(e);
      ox = p.x - ov.offsetLeft;
      oy = p.y - ov.offsetTop;
      ov.style.cursor = 'grabbing';
    }
    function move(e) {
      if (!isDraggingTryOn) return;
      var p = pt(e);
      var nx = p.x - ox, ny = p.y - oy;
      ov.style.left = nx + 'px';
      ov.style.top = ny + 'px';
      smoothX = nx + ov.offsetWidth / 2;
      smoothY = ny + ov.offsetHeight / 2;
      e.preventDefault();
    }
    function up() {
      isDraggingTryOn = false;
      ov.style.cursor = 'grab';
    }
    ov.addEventListener('mousedown', down);
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
    ov.addEventListener('touchstart', down);
    window.addEventListener('touchmove', move, { passive: false });
    window.addEventListener('touchend', up);

    var sizeEl = document.getElementById('trySize');
    if (sizeEl) {
      sizeEl.addEventListener('input', function() {
        var s = +this.value;
        ov.style.width = s + 'px';
        ov.style.height = s + 'px';
        smoothSize = s;
      });
    }
    var rotEl = document.getElementById('tryRot');
    if (rotEl) {
      rotEl.addEventListener('input', function() {
        var r = +this.value;
        ov.style.transform = 'rotate(' + r + 'deg)';
        smoothRot = r;
      });
    }
  })();

  // cursor glow
  (function(){
    var g=document.getElementById('glow');
    if(g && window.matchMedia && window.matchMedia('(hover:hover)').matches){
      window.addEventListener('mousemove',function(e){g.style.left=e.clientX+'px';g.style.top=e.clientY+'px';});
    }
  })();

  // scroll progress
  window.addEventListener('scroll',function(){
    var h=document.documentElement;
    var progressEl = document.getElementById('progress');
    if (!h || !progressEl) return;
    var p=(h.scrollTop)/(h.scrollHeight-h.clientHeight)*100;
    progressEl.style.width=p+'%';
  });

  // hero parallax
  window.addEventListener('mousemove',function(e){
    if(window.innerWidth <= 960) return;
    var r=document.getElementById('heroSculpture')||document.getElementById('heroRings');
    if(!r)return;
    var x=(e.clientX/window.innerWidth-.5),y=(e.clientY/window.innerHeight-.5);
    r.style.transform='translate3d('+(x*22)+'px,'+(y*22)+'px,0) scale(1.05)';
  });
}
// magnetic buttons
function bindMagnetic(){Array.prototype.forEach.call(document.querySelectorAll('.page.active .btn'),function(b){if(b._mag)return;b._mag=1;b.addEventListener('mousemove',function(e){var r=b.getBoundingClientRect();b.style.transform='translate('+((e.clientX-r.left-r.width/2)*.2)+'px,'+((e.clientY-r.top-r.height/2)*.3)+'px)';});b.addEventListener('mouseleave',function(){b.style.transform='';});});}
// 3D tilt
function bindTilt(){Array.prototype.forEach.call(document.querySelectorAll('.page.active .tilt'),function(c){if(c._tilt)return;c._tilt=1;c.addEventListener('mousemove',function(e){var r=c.getBoundingClientRect();var rx=((e.clientY-r.top)/r.height-.5)*-8,ry=((e.clientX-r.left)/r.width-.5)*8;c.style.transform='perspective(800px) rotateX('+rx+'deg) rotateY('+ry+'deg) translateY(-6px)';});c.addEventListener('mouseleave',function(){c.style.transform='';});});}
// reveal
var io;
function observeReveals(){
  var els=document.querySelectorAll('.page.active .reveal:not(.in)');
  if(!('IntersectionObserver' in window)){
    Array.prototype.forEach.call(els,function(e){e.classList.add('in');});
    return;
  }
  if(!io){
    io=new IntersectionObserver(function(entries){
      entries.forEach(function(x){
        if(x.isIntersecting){
          x.target.classList.add('in');
          io.unobserve(x.target);
        }
      });
    },{threshold:0.01, rootMargin:'150px 0px 150px 0px'});
  }
  var i=0;
  Array.prototype.forEach.call(els,function(e){
    e.style.transitionDelay=(i%4*40)+'ms';
    io.observe(e);
    i++;
  });
}

function nav(p){
  var el=document.getElementById('page-'+p);
  if(el){
    if(typeof history!=='undefined'&&history.pushState){
      try{history.pushState(null,'','#'+p);}catch(e){}
    }
    go(p);
  }else{
    location.href=(window.ASTR&&window.ASTR.root?window.ASTR.root:'/')+'#'+p;
  }
}
function enquire(){
  var d=design(pstate.designId),m=mById(pstate.metal),s=sById(pstate.stone),c=calcFor(pstate.metal,pstate.stone);
  var email=(window.ASTR&&window.ASTR.careEmail)?window.ASTR.careEmail:'arthtribez@gmail.com';
  var cur=CURRENCIES[currentCurrency]||CURRENCIES.INR;
  var subject='ASTR Bespoke Order Request — '+d.name+' '+(pstate.type==='necklace'?'Necklace':'Bracelet');
  var priceStr=formatMoney(c.total);
  if(cur.code !== 'INR') priceStr += ' (approx ₹' + inr(c.total) + ' INR)';

  var body='I would like to order this bespoke personalised piece:\n\n'
    +'• Design: '+d.name+' ('+d.category+' - '+d.element+')\n'
    +'• Format: '+(pstate.type==='necklace'?'Necklace':'Bracelet')+'\n'
    +'• Metal & Purity: '+m.name+'\n'
    +'• Crystal Heart: '+s.name+'\n'
    +'• Size: '+pstate.size+' ('+pstate.elSize+' element)\n'
    +'• Indicative Price: ' + priceStr + '\n\n'
    +'Delivery Destination (City, State/Province, Country):\n'
    +'Client Name:\n'
    +'Contact Phone Number:\n'
    +'Special Requests / Inscriptions:';

  window.location.href='mailto:'+email+'?subject='+encodeURIComponent(subject)+'&body='+encodeURIComponent(body);
  toast('Opening your personalised order request...');
}
/* ================= LIVE GOLD & FOREX SYNC ================= */
function applyLiveRate(perGram22K, perGram24K){
  if(typeof perGram22K === 'number' && isFinite(perGram22K) && perGram22K > 5000 && perGram22K < 35000){
    goldRate = perGram22K;
    RATE_22K = perGram22K;
    RATE_24K = (typeof perGram24K === 'number' && isFinite(perGram24K) && perGram24K > 0) ? perGram24K : Math.round(perGram22K / 0.9167);
    if(typeof module !== 'undefined' && module.exports){
      module.exports.goldRate = goldRate;
    }
    updateRateTag();
    var grVal = document.getElementById('grVal');
    if(grVal) grVal.textContent = formatMoney(goldRate) + '/g';
    var grSlider = document.getElementById('grSlider');
    if(grSlider) grSlider.value = goldRate;
    renderHome();
    if(document.getElementById('page-product') && document.getElementById('page-product').classList.contains('active')){
      updatePrice(true);
    }
  }
}

function syncLiveGoldRate(){
  var endpoints = [
    'https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/xau.json',
    'https://latest.currency-api.pages.dev/v1/currencies/xau.json'
  ];
  function tryFetch(idx){
    if(idx >= endpoints.length) return;
    fetch(endpoints[idx])
      .then(function(res){if(!res.ok) throw new Error('HTTP error'); return res.json();})
      .then(function(data){
        if(data && data.xau && typeof data.xau.inr === 'number' && isFinite(data.xau.inr) && data.xau.inr > 0){
          var inrPerOz = data.xau.inr;
          var g24k = inrPerOz / 31.1034768;
          var g22k = Math.round(g24k * 0.9167);
          applyLiveRate(g22k, Math.round(g24k));
        } else {
          tryFetch(idx + 1);
        }
      })
      .catch(function(){
        tryFetch(idx + 1);
      });
  }
  tryFetch(0);
}

function syncForexRates(){
  var endpoints = [
    'https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/inr.json',
    'https://latest.currency-api.pages.dev/v1/currencies/inr.json'
  ];
  function tryFetchForex(idx){
    if(idx >= endpoints.length) return;
    fetch(endpoints[idx])
      .then(function(res){if(!res.ok) throw new Error('HTTP error'); return res.json();})
      .then(function(data){
        if(data && data.inr && typeof data.inr === 'object'){
          var updated = false;
          for(var c in CURRENCIES){
            if(c !== 'INR'){
              var key = c.toLowerCase();
              var rateVal = data.inr[key];
              if(typeof rateVal === 'number' && isFinite(rateVal) && rateVal > 0){
                CURRENCIES[c].rate = rateVal;
                updated = true;
              }
            }
          }
          if(updated){
            updateRateTag();
            if(typeof ASTR_CART !== 'undefined' && ASTR_CART.renderDrawer) {
              ASTR_CART.renderDrawer();
            }
            if(currentCurrency !== 'INR'){
              renderHome();
              if(document.getElementById('page-product') && document.getElementById('page-product').classList.contains('active')){
                updatePrice(true);
              }
            }
          }
        } else {
          tryFetchForex(idx + 1);
        }
      })
      .catch(function(){
        tryFetchForex(idx + 1);
      });
  }
  tryFetchForex(0);
}

/* ================= NATIVE SHOPIFY AJAX CART ENGINE & SLIDE-OUT DRAWER ================= */
var ASTR_CART = (function() {
  var storageKey = 'astr_cart_local';
  var cartQueue = Promise.resolve();
  var lastFocusedElement = null;
  var cartState = {
    token: 'astr_cart_session',
    note: '',
    attributes: {},
    original_total_price: 0,
    total_price: 0,
    total_discount: 0,
    total_weight: 0,
    item_count: 0,
    items: [],
    requires_shipping: true,
    currency: 'INR',
    items_subtotal_price: 0
  };

  try {
    if (typeof localStorage !== 'undefined') {
      var stored = localStorage.getItem(storageKey);
      if (stored) {
        var parsed = JSON.parse(stored);
        if (parsed && Array.isArray(parsed.items)) {
          cartState = parsed;
        }
      }
    }
  } catch(e) {}

  function enqueue(operation) {
    var next = cartQueue.then(function() {
      return operation();
    }, function() {
      return operation();
    });
    cartQueue = next.catch(function(err) {
      console.warn('ASTR_CART operation error:', err);
    });
    return next;
  }

  function saveLocalState() {
    try {
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem(storageKey, JSON.stringify(cartState));
      }
    } catch(e) {}
  }

  function getEndpoints() {
    var base = (typeof window !== 'undefined' && window.ASTR && window.ASTR.root) ? window.ASTR.root.replace(/\/$/, '') : '';
    return {
      add: (typeof window !== 'undefined' && window.ASTR && window.ASTR.cartAddUrl) || (base + '/cart/add.js'),
      get: (typeof window !== 'undefined' && window.ASTR && window.ASTR.cartUrl) ? (window.ASTR.cartUrl.replace(/\/$/, '') + '.js') : (base + '/cart.js'),
      change: (typeof window !== 'undefined' && window.ASTR && window.ASTR.cartChangeUrl) || (base + '/cart/change.js'),
      clear: (typeof window !== 'undefined' && window.ASTR && window.ASTR.cartClearUrl) || (base + '/cart/clear.js'),
      checkout: (typeof window !== 'undefined' && window.ASTR && window.ASTR.checkoutUrl) || (base + '/checkout')
    };
  }

  function extractProperties(item) {
    if (!item) return {};
    var raw = item.properties;
    if (!raw) return {};
    if (typeof raw === 'object' && !Array.isArray(raw)) return raw;
    var out = {};
    if (Array.isArray(raw)) {
      raw.forEach(function(p) {
        if (p && typeof p === 'object') {
          if (p.name !== undefined) out[p.name] = p.value;
          else if (p.first !== undefined) out[p.first] = p.last;
          else {
            for (var k in p) { out[k] = p[k]; }
          }
        }
      });
    }
    return out;
  }

  function recalculateTotals() {
    var count = 0;
    var totalINR = 0;
    cartState.items.forEach(function(item) {
      var q = (typeof item.quantity === 'number' && item.quantity > 0) ? item.quantity : 1;
      count += q;
      var props = extractProperties(item);
      var unitPrice = 0;
      if (props._UnitPriceINR) {
        unitPrice = +props._UnitPriceINR;
      } else if (typeof item.price === 'number') {
        unitPrice = item.price / 100;
      }
      totalINR += unitPrice * q;
    });
    cartState.item_count = count;
    cartState.total_price = totalINR;
    cartState.original_total_price = totalINR;
    cartState.items_subtotal_price = totalINR;
    saveLocalState();
  }

  function buildPayload(state) {
    var p = state || (typeof pstate !== 'undefined' ? pstate : {});
    var d = design(p.designId) || DESIGNS[0];
    var mId = p.metal || '18K';
    var sId = p.stone || 'diamond';
    var mObj = mById(mId) || METALS[4];
    var sObj = sById(sId) || STONES[0];
    var effectiveMetalId = mObj.id;
    var effectiveStoneId = sObj.id;
    var type = p.type || 'necklace';
    var size = p.size || (type === 'necklace' ? '18 in' : '16 cm');
    var elSize = p.elSize || 'Small';
    var currentRate = (typeof p.goldRate === 'number' && p.goldRate > 0) ? p.goldRate : (typeof goldRate !== 'undefined' ? goldRate : 13100);
    var c = calcFor(effectiveMetalId, effectiveStoneId, currentRate);
    var qty = (typeof p.quantity === 'number' && p.quantity > 0) ? Math.floor(p.quantity) : (parseInt(p.quantity, 10) > 0 ? parseInt(p.quantity, 10) : 1);

    var metalLabel = effectiveMetalId === '18K' ? '18K Gold' :
                     effectiveMetalId === '14K' ? '14K Gold' :
                     effectiveMetalId === '9K' ? '9K Gold' :
                     effectiveMetalId === 'silver-rhodium' ? '925 Rhodium Silver' :
                     effectiveMetalId === 'silver-guilded' ? '925 Gilded Silver' : mObj.name;

    var categoryLabel = d.shape === 'AARA' ? 'Divine Masculine Energy' : 'Divine Feminine Energy';
    var designLabel = d.shape;
    var goldBenchmarkLabel = '₹' + inr(currentRate) + '/g';

    var photos = getCustomizedPhotos(d.id, effectiveMetalId, type, effectiveStoneId);
    var photoKey = (photos && photos.length > 0) ? photos[0].key : (d.photos && d.photos[0] ? d.photos[0] : '');

    var variantId = (typeof window !== 'undefined' && window.ASTR && window.ASTR.defaultVariantId && window.ASTR.defaultVariantId !== 1) ? window.ASTR.defaultVariantId : null;

    if (typeof window !== 'undefined' && window.ASTR && Array.isArray(window.ASTR.variants) && window.ASTR.variants.length > 0) {
      var shapeNeedle = (d.shape || '').toUpperCase();
      var metalNeedle = (effectiveMetalId === 'silver-rhodium' || effectiveMetalId === 'silver-guilded') ? 'SILVER' : (effectiveMetalId || '').toUpperCase();

      var matched = window.ASTR.variants.find(function(v) {
        if (!v || !v.available) return false;
        var t = (v.title || '').toUpperCase();
        var pt = (v.product_title || '').toUpperCase();
        var matchesShape = pt.indexOf(shapeNeedle) !== -1 || t.indexOf(shapeNeedle) !== -1;
        var matchesMetal = t.indexOf(metalNeedle) !== -1;
        return matchesShape && matchesMetal;
      });

      if (!matched) {
        matched = window.ASTR.variants.find(function(v) {
          if (!v || !v.available) return false;
          var t = (v.title || '').toUpperCase();
          return t.indexOf(metalNeedle) !== -1;
        });
      }

      if (matched && matched.id) {
        variantId = matched.id;
      }
    }

    return {
      id: variantId,
      quantity: qty,
      properties: {
        '_Design': designLabel,
        '_Category': categoryLabel,
        '_Element': d.element,
        '_Metal': metalLabel,
        '_Stone': sObj.name,
        '_Format': type === 'necklace' ? 'Necklace' : 'Bracelet',
        '_Size': size,
        '_GoldBenchmark': goldBenchmarkLabel,
        '_Energisation': 'Activated with cosmic energy',
        '_ElementSize': elSize,
        '_DesignId': d.id,
        '_DesignName': d.name,
        '_StoneColor': sObj.color,
        '_DesignColor': d.color,
        '_ThumbnailKey': photoKey,
        '_UnitPriceINR': c.total
      }
    };
  }

  function fetchCartDirect() {
    var eps = getEndpoints();
    if (typeof fetch === 'undefined') {
      recalculateTotals();
      renderDrawer();
      return Promise.resolve(cartState);
    }
    return fetch(eps.get, {
      method: 'GET',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    })
    .then(function(res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    })
    .then(function(data) {
      if (data && typeof data.item_count === 'number') {
        cartState = data;
        saveLocalState();
      }
      renderDrawer();
      return cartState;
    })
    .catch(function() {
      recalculateTotals();
      renderDrawer();
      return cartState;
    });
  }

  function getCart() {
    return enqueue(function() {
      return fetchCartDirect();
    });
  }

  function addItem(payload) {
    return enqueue(function() {
      var p = payload || buildPayload(typeof pstate !== 'undefined' ? pstate : {});
      var eps = getEndpoints();

      if (!p.id || typeof fetch === 'undefined') {
        return fallbackAdd(p);
      }

      return fetch(eps.add, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(p)
      })
      .then(function(res) {
        if (res.status === 422) {
          return res.json().then(function(errData) {
            var err = new Error(errData.description || errData.message || 'Variant sold out / inventory limit reached');
            err.status = 422;
            err.data = errData;
            return Promise.reject(err);
          });
        }
        if (!res.ok) {
          // If Shopify returns 404 / 500 error, smoothly fallback to customizer cart drawer
          return fallbackAdd(p);
        }
        return res.json().then(function() {
          return fetchCartDirect();
        });
      })
      .catch(function(err) {
        if (err && err.status === 422) {
          return Promise.reject(err);
        }
        // Gracefully add to cart drawer on any network or variant error
        return fallbackAdd(p);
      });
    });
  }

  function fallbackAdd(p) {
    var uniqueKey = 'astr_' + Date.now() + '_' + Math.random().toString(36).substr(2, 6);
    var itemProps = extractProperties(p);
    var itemPrice = (itemProps && itemProps._UnitPriceINR) || (typeof pstate !== 'undefined' ? calcFor(pstate.metal, pstate.stone).total : 145000);
    var newItem = {
      id: p.id,
      key: uniqueKey,
      title: (itemProps && itemProps._DesignName) || 'ASTR Bespoke Jewel',
      product_title: (itemProps && itemProps._DesignName) || 'ASTR Bespoke Jewel',
      variant_title: (itemProps && itemProps._Metal) || 'Custom Finish',
      quantity: p.quantity || 1,
      price: itemPrice,
      line_price: itemPrice * (p.quantity || 1),
      final_line_price: itemPrice * (p.quantity || 1),
      properties: itemProps || {}
    };

    cartState.items.unshift(newItem);
    recalculateTotals();
    renderDrawer();
    return Promise.resolve(cartState);
  }

  function updateQuantity(keyOrIndex, newQty) {
    return enqueue(function() {
      var qty = parseInt(newQty, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      var eps = getEndpoints();

      var isClientItem = false;
      if (cartState.items) {
        for (var i = 0; i < cartState.items.length; i++) {
          var it = cartState.items[i];
          if (it.key === keyOrIndex || String(i) === String(keyOrIndex) || it.id === keyOrIndex) {
            if (!it.id) {
              isClientItem = true;
            }
            break;
          }
        }
      }

      if (isClientItem || typeof fetch === 'undefined') {
        return fallbackUpdate(keyOrIndex, qty);
      }

      return fetch(eps.change, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: keyOrIndex, quantity: qty })
      })
      .then(function(res) {
        if (res.status === 422) {
          return res.json().then(function(errData) {
            var err = new Error(errData.description || errData.message || 'Cannot exceed inventory limit');
            err.status = 422;
            err.data = errData;
            return Promise.reject(err);
          });
        }
        if (!res.ok) {
          return fallbackUpdate(keyOrIndex, qty);
        }
        return res.json();
      })
      .then(function(data) {
        if (data && typeof data.item_count === 'number') {
          cartState = data;
          saveLocalState();
        } else {
          return fetchCartDirect();
        }
        renderDrawer();
        return cartState;
      })
      .catch(function(err) {
        if (err && err.status === 422) {
          return Promise.reject(err);
        }
        return fallbackUpdate(keyOrIndex, qty);
      });
    });
  }

  function fallbackUpdate(keyOrIndex, qty) {
    var foundIdx = -1;
    for (var i = 0; i < cartState.items.length; i++) {
      if (cartState.items[i].key === keyOrIndex || String(i) === String(keyOrIndex) || cartState.items[i].id === keyOrIndex) {
        foundIdx = i;
        break;
      }
    }
    if (foundIdx >= 0) {
      if (qty <= 0) {
        cartState.items.splice(foundIdx, 1);
      } else {
        cartState.items[foundIdx].quantity = qty;
        cartState.items[foundIdx].line_price = cartState.items[foundIdx].price * qty;
        cartState.items[foundIdx].final_line_price = cartState.items[foundIdx].line_price;
      }
      recalculateTotals();
    }
    renderDrawer();
    return Promise.resolve(cartState);
  }

  function removeItem(keyOrIndex) {
    return updateQuantity(keyOrIndex, 0);
  }

  function clearCart() {
    return enqueue(function() {
      var eps = getEndpoints();
      if (typeof fetch === 'undefined') {
        cartState.items = [];
        recalculateTotals();
        renderDrawer();
        return Promise.resolve(cartState);
      }
      return fetch(eps.clear, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
      })
      .then(function() {
        cartState.items = [];
        recalculateTotals();
        renderDrawer();
        return cartState;
      })
      .catch(function() {
        cartState.items = [];
        recalculateTotals();
        renderDrawer();
        return cartState;
      });
    });
  }

  function renderDrawer() {
    if (typeof document === 'undefined') return;

    var count = cartState.item_count || (cartState.items ? cartState.items.reduce(function(acc, i){ return acc + (i.quantity || 1); }, 0) : 0);
    var subtotalINR = 0;
    if (cartState.items && cartState.items.length > 0) {
      subtotalINR = cartState.items.reduce(function(acc, i) {
        var props = extractProperties(i);
        var up = props._UnitPriceINR ? +props._UnitPriceINR : (typeof i.price === 'number' ? i.price / 100 : 0);
        return acc + (up * (i.quantity || 1));
      }, 0);
    } else {
      subtotalINR = 0;
    }

    var badge = document.getElementById('cartCountBadge');
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
      if (count > 0) {
        badge.classList.remove('pulse');
        void badge.offsetWidth;
        badge.classList.add('pulse');
      }
    }
    var mobBadge = document.getElementById('mobCartCountBadge');
    if (mobBadge) {
      mobBadge.textContent = count;
      mobBadge.style.display = count > 0 ? 'inline-flex' : 'none';
    }

    var drawerCount = document.getElementById('cartDrawerCount');
    if (drawerCount) {
      drawerCount.textContent = count + (count === 1 ? ' item' : ' items');
    }

    var subtotalEl = document.getElementById('cartDrawerSubtotal');
    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(subtotalINR);
    }

    var checkoutBtn = document.getElementById('cartCheckoutBtn');
    var waBtn = document.getElementById('cartWhatsAppBtn');
    if (checkoutBtn) {
      if (count <= 0) {
        checkoutBtn.setAttribute('disabled', 'true');
        checkoutBtn.style.opacity = '0.5';
        checkoutBtn.style.pointerEvents = 'none';
      } else {
        checkoutBtn.removeAttribute('disabled');
        checkoutBtn.style.opacity = '1';
        checkoutBtn.style.pointerEvents = 'auto';
      }
    }
    if (waBtn) {
      if (count <= 0) {
        waBtn.setAttribute('disabled', 'true');
        waBtn.style.opacity = '0.5';
        waBtn.style.pointerEvents = 'none';
      } else {
        waBtn.removeAttribute('disabled');
        waBtn.style.opacity = '1';
        waBtn.style.pointerEvents = 'auto';
      }
    }

    var bodyEl = document.getElementById('cartDrawerBody');
    if (!bodyEl) return;

    if (!cartState.items || cartState.items.length === 0) {
      bodyEl.innerHTML =
        '<div class="cart-empty-state">' +
          '<div class="cart-empty-art">' +
            '<svg viewBox="0 0 100 100" width="68" height="68" fill="none" stroke="#C3A567" stroke-width="1.2">' +
              '<circle cx="50" cy="50" r="42" stroke-dasharray="3 3"/>' +
              '<circle cx="50" cy="50" r="28" stroke="#9a7ec4" stroke-width="1.4"/>' +
              '<circle cx="50" cy="50" r="8" fill="#C3A567"/>' +
            '</svg>' +
          '</div>' +
          '<h3>Your Sacred Bag is Empty</h3>' +
          '<p>Each ASTR creation is an intentional energetic vessel, handcrafted and consecrated upon order.</p>' +
          '<div class="cart-empty-actions">' +
            '<button class="btn btn-primary" onclick="closeCartDrawer();go(\'aara\')"><span class="t">Explore AARA</span></button>' +
            '<button class="btn btn-ghost" onclick="closeCartDrawer();go(\'deu\')"><span class="t">Explore DEU</span></button>' +
          '</div>' +
        '</div>';
      return;
    }

    var assets = (typeof window !== 'undefined' && window.ASTR_ASSETS) ? window.ASTR_ASSETS : {};
    var itemsHtml = cartState.items.map(function(item, idx) {
      var rawKey = item.key || String(idx);
      var safeKey = String(rawKey).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, "\\'");
      var props = extractProperties(item);
      var itemTitle = props._DesignName || item.product_title || item.title || 'ASTR Bespoke Jewel';
      var dMetal = props._Metal || '18K Gold';
      var dStone = props._Stone || 'Diamond';
      var dFormat = props._Format || 'Necklace';
      var dSize = props._Size || '18 in';
      var dElSize = props._ElementSize ? (' · ' + props._ElementSize) : '';
      var dEnergy = props._Energisation || 'Activated with cosmic energy';
      var sColor = props._StoneColor || '#ffffff';
      var dColor = props._DesignColor || '#9a7ec4';

      var unitPrice = props._UnitPriceINR ? +props._UnitPriceINR : (typeof item.price === 'number' ? item.price / 100 : 0);
      var linePrice = unitPrice * (item.quantity || 1);

      var rings = (props._Design && (props._Design.indexOf('6') >= 0 || props._Design.toUpperCase().indexOf('DEU') >= 0)) ? 6 : 5;
      var fallbackSvg = ringArt(rings, dColor, sColor, '#d4af37');
      var thumbHtml = '';
      var thumbKey = props._ThumbnailKey;

      if (item.image) {
        thumbHtml = '<img src="' + item.image + '" alt="' + itemTitle + '" width="84" height="84" loading="lazy" onerror="this.style.display=\'none\';if(this.nextElementSibling)this.nextElementSibling.style.display=\'block\';">' +
          '<svg viewBox="0 0 200 200" style="display:none">' + fallbackSvg + '</svg>';
      } else if (thumbKey && assets[thumbKey]) {
        thumbHtml = '<img src="' + assets[thumbKey] + '" alt="' + itemTitle + '" width="84" height="84" loading="lazy" onerror="this.style.display=\'none\';if(this.nextElementSibling)this.nextElementSibling.style.display=\'block\';">' +
          '<svg viewBox="0 0 200 200" style="display:none">' + fallbackSvg + '</svg>';
      } else {
        thumbHtml = '<svg viewBox="0 0 200 200">' + fallbackSvg + '</svg>';
      }

      return '<div class="cart-item" data-cart-key="' + safeKey + '">' +
        '<div class="cart-item-thumb">' + thumbHtml + '</div>' +
        '<div class="cart-item-info">' +
          '<div class="cart-item-head">' +
            '<h4 class="cart-item-title">' + itemTitle + '</h4>' +
            '<button type="button" class="cart-item-remove" onclick="ASTR_CART.removeItem(\'' + safeKey + '\')" title="Remove item" aria-label="Remove ' + itemTitle + '">&times;</button>' +
          '</div>' +
          '<div class="cart-item-props">' +
            '<span class="prop-badge format-badge">' + dFormat + ' · ' + dSize + dElSize + '</span>' +
            '<span class="prop-badge metal-badge">' + dMetal + '</span>' +
            '<span class="prop-badge stone-badge"><span class="swatch-dot" style="background:' + sColor + '"></span>' + dStone + '</span>' +
            '<span class="prop-badge energy-badge">⚡ ' + dEnergy + '</span>' +
          '</div>' +
          '<div class="cart-item-price-qty">' +
            '<div class="cart-qty-ctrl">' +
              '<button type="button" class="qty-btn" onclick="ASTR_CART.updateQuantity(\'' + safeKey + '\',' + ((item.quantity || 1) - 1) + ')" aria-label="Decrease quantity">−</button>' +
              '<span class="qty-num">' + (item.quantity || 1) + '</span>' +
              '<button type="button" class="qty-btn" onclick="ASTR_CART.updateQuantity(\'' + safeKey + '\',' + ((item.quantity || 1) + 1) + ')" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<div class="cart-item-price">' + formatMoney(linePrice) + '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');

    bodyEl.innerHTML = itemsHtml;
  }

  function trapFocus(e) {
    var drawer = document.getElementById('cartDrawer');
    if (!drawer || !drawer.classList.contains('open')) return;

    if (e.key === 'Tab') {
      var focusables = drawer.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!focusables || focusables.length === 0) {
        e.preventDefault();
        return;
      }
      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first || !drawer.contains(document.activeElement)) {
          e.preventDefault();
          if (typeof last.focus === 'function') last.focus();
        }
      } else {
        if (document.activeElement === last || !drawer.contains(document.activeElement)) {
          e.preventDefault();
          if (typeof first.focus === 'function') first.focus();
        }
      }
    }
  }

  function openDrawer() {
    if (typeof document === 'undefined') return;
    if (typeof closeTryOn === 'function') {
      var tryModal = document.getElementById('tryModal');
      if (tryModal && tryModal.classList.contains('open')) {
        closeTryOn();
      }
    }
    lastFocusedElement = document.activeElement;
    var drawer = document.getElementById('cartDrawer');
    var backdrop = document.getElementById('cartDrawerBackdrop');
    if (drawer) {
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      if (typeof drawer.removeAttribute === 'function') drawer.removeAttribute('inert');
      var closeBtn = document.getElementById('cartDrawerCloseBtn') || drawer.querySelector('.cart-drawer-close');
      if (closeBtn && typeof closeBtn.focus === 'function') {
        setTimeout(function() { closeBtn.focus(); }, 40);
      } else if (typeof drawer.focus === 'function') {
        drawer.focus();
      }
    }
    if (backdrop) {
      backdrop.classList.add('open');
      backdrop.setAttribute('aria-hidden', 'false');
    }
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (typeof document === 'undefined') return;
    var drawer = document.getElementById('cartDrawer');
    var backdrop = document.getElementById('cartDrawerBackdrop');
    if (drawer) {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      if (typeof drawer.setAttribute === 'function') drawer.setAttribute('inert', '');
    }
    if (backdrop) {
      backdrop.classList.remove('open');
      backdrop.setAttribute('aria-hidden', 'true');
    }
    if (document.body && document.body.style) {
      document.body.style.overflow = '';
    }
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      var isInsideDrawer = drawer && typeof drawer.contains === 'function' && drawer.contains(lastFocusedElement);
      if (!isInsideDrawer) {
        try { lastFocusedElement.focus(); } catch(e){}
      }
    }
  }

  if (typeof document !== 'undefined') {
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        var drawer = document.getElementById('cartDrawer');
        if (drawer && drawer.classList.contains('open')) {
          closeDrawer();
        }
      } else if (e.key === 'Tab') {
        trapFocus(e);
      }
    });
  }

  if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
    window.addEventListener('storage', function(e) {
      if (e.key === storageKey && e.newValue) {
        try {
          var parsed = JSON.parse(e.newValue);
          if (parsed && Array.isArray(parsed.items)) {
            cartState = parsed;
            renderDrawer();
          }
        } catch(err) {}
      }
    });
  }

  return {
    getCart: getCart,
    addItem: addItem,
    updateQuantity: updateQuantity,
    removeItem: removeItem,
    clearCart: clearCart,
    buildPayload: buildPayload,
    renderDrawer: renderDrawer,
    openDrawer: openDrawer,
    closeDrawer: closeDrawer,
    trapFocus: trapFocus,
    extractProperties: extractProperties,
    getState: function() { return cartState; },
    recalculateTotals: recalculateTotals
  };
})();

if (typeof window !== 'undefined') {
  window.ASTR_CART = ASTR_CART;
  window.openCartDrawer = function() { ASTR_CART.openDrawer(); };
  window.closeCartDrawer = function() { ASTR_CART.closeDrawer(); };
  window.toast = toast;

  window.addToBag = function() {
    var btn = document.getElementById('addToBagBtn');
    var origText = btn ? btn.innerHTML : '';
    if (btn) {
      btn.innerHTML = '<span class="t">Adding to Sacred Bag…</span>';
      btn.setAttribute('disabled', 'true');
    }

    var payload = ASTR_CART.buildPayload(typeof pstate !== 'undefined' ? pstate : {});
    var d = design(typeof pstate !== 'undefined' ? pstate.designId : 'aara-purple');
    var pieceName = d ? d.name : 'ASTR Jewel';

    ASTR_CART.addItem(payload)
      .then(function() {
        if (btn) {
          btn.innerHTML = '<span class="t">Added to Sacred Bag ✓</span>';
          setTimeout(function() {
            btn.innerHTML = origText;
            btn.removeAttribute('disabled');
          }, 1400);
        }
        ASTR_CART.openDrawer();
        toast('Added ' + pieceName + ' to your Sacred Bag ✨');
      })
      .catch(function(err) {
        if (btn) {
          btn.innerHTML = origText;
          btn.removeAttribute('disabled');
        }
        if (err && (err.status === 422 || err.status === 400 || err.status === 404)) {
          toast(err.message || 'Item unavailable / allocated');
          return;
        }
        ASTR_CART.openDrawer();
        toast('Added ' + pieceName + ' to your Sacred Bag ✨');
      });
  };

  window.proceedToCheckout = function() {
    var state = ASTR_CART.getState();
    if (!state.items || state.items.length === 0) {
      toast('Your Sacred Bag is empty');
      return;
    }

    var checkoutBtn = document.getElementById('cartCheckoutBtn');
    if (checkoutBtn) {
      checkoutBtn.setAttribute('disabled', 'true');
      checkoutBtn.innerHTML = '<span class="t">Connecting to Checkout &middot;&middot;&middot;</span> <span class="arrow">&rarr;</span>';
    }

    var root = (window.ASTR && window.ASTR.root) || '/';
    var checkoutUrl = (window.ASTR && window.ASTR.checkoutUrl) || (root === '/' ? '/checkout' : root + '/checkout');

    var itemsNeedSync = state.items.filter(function(i) {
      var id = i.id || i.variant_id;
      return !id;
    });

    if (itemsNeedSync.length > 0 && typeof fetch !== 'undefined') {
      fetch('/products.json?limit=1')
        .then(function(res) { return res.json(); })
        .then(function(pData) {
          if (pData && pData.products && pData.products[0] && pData.products[0].variants && pData.products[0].variants[0]) {
            var fallbackVarId = pData.products[0].variants[0].id;
            var addPromises = itemsNeedSync.map(function(item) {
              var payload = {
                id: fallbackVarId,
                quantity: item.quantity || 1,
                properties: ASTR_CART.extractProperties(item)
              };
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(payload)
              });
            });
            return Promise.all(addPromises).then(function() {
              window.location.href = checkoutUrl;
            });
          } else {
            window.location.href = checkoutUrl;
          }
        })
        .catch(function() {
          window.location.href = checkoutUrl;
        });
      return;
    }

    window.location.href = checkoutUrl;
  };

  window.submitOrderViaWhatsApp = function() {
    var state = ASTR_CART.getState();
    if (!state.items || state.items.length === 0) {
      toast('Your Sacred Bag is empty');
      return;
    }

    var waNumber = (window.ASTR && window.ASTR.careWa) || '919135933369';
    var lines = ['*ASTR Bespoke Order Request*', ''];

    var grandTotal = 0;
    state.items.forEach(function(item, idx) {
      var props = ASTR_CART.extractProperties(item);
      var name = props._DesignName || item.product_title || item.title || 'ASTR Jewel';
      var qty = item.quantity || 1;
      var unitPrice = props._UnitPriceINR ? +props._UnitPriceINR : 0;
      var lineTotal = unitPrice * qty;
      grandTotal += lineTotal;

      lines.push('*Item ' + (idx + 1) + ': ' + name + '*');
      if (props._Design) lines.push('Design: ' + props._Design);
      if (props._Category) lines.push('Category: ' + props._Category);
      if (props._Element) lines.push('Element: ' + props._Element);
      if (props._Metal) lines.push('Metal: ' + props._Metal);
      if (props._Stone) lines.push('Stone: ' + props._Stone);
      if (props._Format) lines.push('Format: ' + props._Format);
      if (props._Size) lines.push('Size: ' + props._Size);
      if (props._Energisation) lines.push('Energisation: ' + props._Energisation);
      lines.push('Qty: ' + qty);
      lines.push('Price: Rs.' + inr(lineTotal));
      lines.push('');
    });

    lines.push('*Grand Total: Rs.' + inr(grandTotal) + '*');
    lines.push('');
    lines.push('Please confirm availability and share payment details.');

    var msg = encodeURIComponent(lines.join('\n'));
    var url = 'https://wa.me/' + waNumber + '?text=' + msg;
    window.open(url, '_blank');
    toast('Opening WhatsApp with your order details...');
  };
}

/* ================= INIT ================= */
if (typeof document !== 'undefined') {
  updateRateTag();
  var sel1 = document.getElementById('curSelector');
  if(sel1) sel1.value = currentCurrency;
  var sel2 = document.getElementById('mobCurSelector');
  if(sel2) sel2.value = currentCurrency;

  renderHome();renderStones();
  syncLiveGoldRate();syncForexRates();
  if (typeof ASTR_CART !== 'undefined') ASTR_CART.getCart();

  (function(){
    if (typeof location === 'undefined') return;
    var ps=["home","aara","deu","story","energy","founders","stones","sizes","returns","privacy","payment-guide","shipping","contact","packaging","product"];
    var routeToHash = function() {
      var h=(location.hash||"").replace("#","");
      if (h && h !== 'home' && ps.indexOf(h) >= 0) {
        go(h);
      }
    };
    routeToHash();
    if (typeof window !== 'undefined') {
      window.addEventListener('hashchange', routeToHash);
    }
  })();
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    ASTR_CART: ASTR_CART,
    DESIGNS: DESIGNS,
    METALS: METALS,
    STONES: STONES,
    CURRENCIES: CURRENCIES,
    calcFor: calcFor,
    metalCostFor: metalCostFor,
    formatMoney: formatMoney,
    getConvertedValue: getConvertedValue,
    getCustomizedPhotos: getCustomizedPhotos,
    pstate: pstate,
    goldRate: goldRate,
    getGoldRate: function() { return goldRate; },
    toast: toast,
    syncForexRates: syncForexRates,
    syncLiveGoldRate: syncLiveGoldRate,
    applyLiveRate: applyLiveRate,
    ringArt: ringArt,
    switchGallery: switchGallery,
    renderProductGallery: renderProductGallery,
    renderProduct: renderProduct,
    bindProduct: bindProduct,
    openProduct: openProduct,
    updateViz: updateViz,
    previewViz: previewViz,
    commitChip: commitChip,
    design: design,
    mById: mById,
    sById: sById,
    updatePrice: updatePrice,
    setPrice: setPrice,
    previewPrice: previewPrice,
    openTryOn: openTryOn,
    closeTryOn: closeTryOn,
    startCam: startCam,
    stopCam: stopCam
  };
}


